import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  TablePagination,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Avatar,
  Badge,
  LinearProgress,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Menu,
  ListItemIcon,
  Autocomplete,
  CircularProgress,
  Snackbar,
  ToggleButton,
  ToggleButtonGroup,
  Collapse,
} from '@mui/material';
import {
  Visibility,
  Cancel,
  Upload,
  Search,
  Receipt,
  CheckCircle,
  Pending,
  AttachMoney,
  Home,
  Business,
  Person,
  CalendarToday,
  FilterList,
  Download,
  Refresh,
  TrendingUp,
  WarningAmber,
  Edit,
  Print,
  AccountBalance,
  Description,
  Comment,
  MoneyOff,
  Timeline,
  Save,
  Delete,
  CheckCircleOutline,
  WatchLater,
  PictureAsPdf as PictureAsPdfIcon,
  Close,
  Groups,
  ReceiptLong,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  getBookings,
  getBookingTransactions,
  getBookingProgress,
  getBookingFollowUps,
  createBookingFollowUp,
  getInstallmentPlan,
  getBookingDocuments,
  createRefundReceipt,
  getCommissionGenerator,
  getBookingHierarchy,
  getGroupedCommissionReports,
} from '../../services/project';
import { getBanks, getInquiryStatuses } from '../../services/master';
import Loader from '../../themes/useLoader';
import BookingDetailsPDF from './BookingDetailsPDF';
import DownloadBookingTabPDF from './DownloadBookingTabPDF';
import ExportButton from '../../components/ExportButton/ExportButton';
import RefreshButton from '../../components/RefreshButton/RefreshButton';
import {
  exportAsPDF as exportPDFUtil,
  exportAsExcel,
} from '../../utils/importExport';

import { hasWritePermission, hasReadPermission } from '../../utils/menuFilter';

const BookingDetaila = () => {
  const canWriteBooking =
    hasWritePermission('booking.booking-details') ||
    hasWritePermission('plot-booking.booking-details');
  const canReadBooking =
    hasReadPermission('booking.booking-details') ||
    hasReadPermission('plot-booking.booking-details');
  const canCancelBooking =
    hasWritePermission('booking.cancel-plot-booking') ||
    hasWritePermission('plot-booking.cancel-plot-booking');

  const canViewCommission = hasWritePermission('booking.commission');
  const canViewFollowup = hasWritePermission('booking.followup');
  const canViewReceipt = hasWritePermission('booking.receipt');
  const canViewRefundReceipt = hasWritePermission('booking.refund-receipt');
  const canViewDocument = hasWritePermission('booking.document');
  const canViewProgress = hasWritePermission('booking.progress');
  const canViewStatus = hasWritePermission('booking.booking-status');
  const history = useHistory();
  const location = useLocation();
  const [searchForm, setSearchForm] = useState({
    bookingID: '',
    site: '',
    plotNo: '',
    loginId: '',
    associateLoginId: '',
    fromDate: '',
    toDate: '',
  });

  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tabValue, setTabValue] = useState(0);
  const [paymentPlanFilter, setPaymentPlanFilter] = useState('all');
  const [paymentPlans, setPaymentPlans] = useState([]);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [viewTabValue, setViewTabValue] = useState(0);
  const [newRefundReceipt, setNewRefundReceipt] = useState({
    receiptNo: '',
    refundDate: '',
    amount: '',
    method: '',
    status: 'Pending',
    remarks: '',
  });
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const exportMenuOpen = Boolean(exportAnchorEl);
  // More Filters state
  const [moreFiltersOpen, setMoreFiltersOpen] = useState(false);
  const [filterBranch, setFilterBranch] = useState('all');
  const [filterFromDate, setFilterFromDate] = useState('');
  const [filterToDate, setFilterToDate] = useState('');
  const [filterMinAmount, setFilterMinAmount] = useState('');
  const [filterMaxAmount, setFilterMaxAmount] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [receipts, setReceipts] = useState([]);
  const [receiptsLoading, setReceiptsLoading] = useState(false);
  const [receiptsError, setReceiptsError] = useState('');
  const [installmentPlan, setInstallmentPlan] = useState(null);
  const [installmentLoading, setInstallmentLoading] = useState(false);
  const [installmentError, setInstallmentError] = useState('');
  const [totalCount, setTotalCount] = useState(0);

  const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
  const [pdfType, setPdfType] = useState('list');

  const availableTabs = [
    { label: 'Booking', show: true },
    { label: 'Installment', show: true },
    { label: 'Receipt', show: canViewReceipt },
    {
      label: 'Refund Receipt',
      show:
        selectedBooking?.status === 'cancelled' &&
        canViewRefundReceipt &&
        canCancelBooking,
    },
    { label: 'Document', show: canViewDocument },
    { label: 'Followup/Remark', show: canViewFollowup },
    { label: 'Commission', show: canViewCommission },
    { label: 'Progress', show: canViewProgress },
  ].filter((t) => t.show);

  const activeTabLabel = availableTabs[viewTabValue]?.label;
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [autoPrintReceipt, setAutoPrintReceipt] = useState(false);

  const [bookingPdfOpen, setBookingPdfOpen] = useState(false);
  const [progressData, setProgressData] = useState([]);
  const [progressLoading, setProgressLoading] = useState(false);
  const [refundBookingInfo, setRefundBookingInfo] = useState(null);

  // Refund dialog state
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [refundFormData, setRefundFormData] = useState({
    bookingId: '',
    amount: '',
    receivedDate: '',
    paymentType: 'partialPayment',
    mode: '',
    refNo: '',
    bankName: '',
    otherRemark: '',
  });
  const [creatingRefund, setCreatingRefund] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [progressError, setProgressError] = useState('');
  const [commissions, setCommissions] = useState([]);
  const [commissionsLoading, setCommissionsLoading] = useState(false);
  const [commissionsError, setCommissionsError] = useState('');
  const [totalCommission, setTotalCommission] = useState(0);
  const [totalDistribution, setTotalDistribution] = useState(0);
  const [isCommissionTypeFixed, setIsCommissionTypeFixed] = useState(false);
  const [fixedCommissionRemark, setFixedCommissionRemark] = useState('');
  const [commissionViewMode, setCommissionViewMode] = useState('detailed'); // 'detailed' | 'grouped'
  const [expandedGroupedRows, setExpandedGroupedRows] = useState({});
  const [commissionsAssociateFilter, setCommissionsAssociateFilter] = useState(null);
  const [associatesList, setAssociatesList] = useState([]);
  const [followUps, setFollowUps] = useState([]);
  const [followUpsLoading, setFollowUpsLoading] = useState(false);
  const [followUpsError, setFollowUpsError] = useState('');
  const [followUpsPage, setFollowUpsPage] = useState(0);
  const [followUpsRowsPerPage, setFollowUpsRowsPerPage] = useState(10);
  const [followUpsTotalCount, setFollowUpsTotalCount] = useState(0);
  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [documentsError, setDocumentsError] = useState('');
  const [banks, setBanks] = useState([]);
  const [inquiryStatuses, setInquiryStatuses] = useState([]);
  const [followUpForm, setFollowUpForm] = useState({
    date: new Date().toISOString(),
    nextFollowUpDate: '',
    status: '',
    remark: '',
  });
  const [savingFollowUp, setSavingFollowUp] = useState(false);
  const [followUpSaveSuccess, setFollowUpSaveSuccess] = useState('');
  const [followUpSaveError, setFollowUpSaveError] = useState('');

  // Map API response to component format
  const mapBookingData = (apiBooking) => {
    // Format booking date
    const bookingDate = apiBooking.bookingDate
      ? new Date(apiBooking.bookingDate).toISOString().split('T')[0]
      : '';

    return {
      id: apiBooking._id,
      bookingId: apiBooking.bookingId ? String(apiBooking.bookingId) : '', // Use bookingId directly from API (convert to string)
      plotBookingDate: bookingDate,
      plotNo: apiBooking.particular?.inventoryDetail || '',
      inventoryType: apiBooking.particular?.inventoryType || '',
      branchName: apiBooking.particular?.projectName || '', // Using projectName as branchName for now
      paymentPlan: apiBooking.paymentPlan || '',
      customer: apiBooking.customer?.name || '',
      associate: apiBooking.associate?.name || '',
      plotAmount: apiBooking.propertyAmount || apiBooking.plotAmount || 0,
      discountAmount:
        apiBooking.discount ||
        apiBooking.discountAmount ||
        apiBooking.companyDiscount ||
        0,
      paidAmount: apiBooking.totalReceived || apiBooking.paidAmount || 0,
      status: apiBooking.approvedStatus || 'pending', // Use approvedStatus directly from API
      // Add authority charge fields
      authorityChargeName: apiBooking.authorityChargeName || '',
      totalAuthorityCharge: apiBooking.totalAuthorityCharge || 0,
      isAuthorityCharges: apiBooking.isAuthorityCharges || false,
      // Add inventory detail fields
      plotWidth:
        apiBooking.inventoryDetails?.width ||
        apiBooking.particular?.width ||
        apiBooking.particular?.plotWidth ||
        '',
      plotLength:
        apiBooking.inventoryDetails?.length ||
        apiBooking.particular?.length ||
        apiBooking.particular?.plotHeight ||
        '',
      plotArea:
        apiBooking.inventoryDetails?.totalSize ||
        apiBooking.particular?.areaSize ||
        '',
      plotRate:
        apiBooking.inventoryDetails?.pricePerSqFt ||
        apiBooking.particular?.plotRate ||
        apiBooking.particular?.pricePerSqFt ||
        '',
      // Add address field
      address:
        apiBooking.customer?.address ||
        apiBooking.customer?.otherDetails?.address ||
        apiBooking.customer?.residentialAddress ||
        '',
      // Include original data for view dialog
      _original: apiBooking,
    };
  };

  // Map tab value to approvedStatus
  const getApprovedStatusFromTab = (tab) => {
    switch (tab) {
      case 1:
        return 'booked';
      case 2:
        return 'registry';
      case 3:
        return 'pending';
      case 4:
        return 'cancelled';
      default:
        return null; // All bookings - no filter
    }
  };

  // Fetch bookings from API with pagination and filters
  const fetchBookings = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const params = {
        page: page + 1, // API uses 1-based pagination
        limit: rowsPerPage,
      };

      // Add approvedStatus filter based on tab
      const approvedStatus = getApprovedStatusFromTab(tabValue);
      if (approvedStatus) {
        params.approvedStatus = approvedStatus;
      }

      // Add payment plan filter if not 'all'
      if (paymentPlanFilter !== 'all') {
        params.paymentPlan = paymentPlanFilter;
      }

      // Add search query if provided
      if (searchQuery) {
        params.search = searchQuery;
        // If it looks like a Mongo ID, search specifically by _id as well
        if (/^[0-9a-fA-F]{24}$/.test(searchQuery)) {
          params._id = searchQuery;
        }
      }

      const response = await getBookings(params);

      // Handle different response structures
      let bookings = [];
      let total = 0;

      if (response.success || response.status === true) {
        // API response structure: { success: true, totalCount: 18, count: 5, data: [...] }
        bookings = Array.isArray(response.data)
          ? response.data
          : response.data?.docs || [];
        // Use totalCount from response (total across all pages), fallback to other fields for backward compatibility
        total =
          response.totalCount ||
          response.data?.totalDocs ||
          response.data?.total ||
          response.count ||
          bookings.length;
      } else if (Array.isArray(response)) {
        bookings = response;
        total = response.length;
      } else if (response.data) {
        bookings = Array.isArray(response.data)
          ? response.data
          : response.data?.docs || [];
        total =
          response.totalCount ||
          response.data?.totalDocs ||
          response.data?.total ||
          response.count ||
          bookings.length;
      }

      const mappedData = bookings.map(mapBookingData);
      setBookingData(mappedData);
      setTotalCount(total);
    } catch (err) {
      console.error('Error fetching bookings:', err);
      setError(err.message || 'Failed to load bookings');
      setBookingData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, [tabValue, page, rowsPerPage, paymentPlanFilter, searchQuery]);

  // Fetch bookings when filters change
  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  // Fetch banks on component mount
  useEffect(() => {
    const fetchBanksData = async () => {
      try {
        const banksData = await getBanks();
        setBanks(banksData || []);
      } catch (err) {
        console.error('Error fetching banks:', err);
      }
    };
    fetchBanksData();
  }, []);

  useEffect(() => {
    const fetchInquiryStatuses = async () => {
      try {
        const statuses = await getInquiryStatuses();
        const leadStatuses = (statuses || []).filter(
          (item) => (item.stageType || '').toLowerCase() === 'lead',
        );
        setInquiryStatuses(leadStatuses);
      } catch (err) {
        console.error('Error fetching inquiry statuses:', err);
      }
    };
    fetchInquiryStatuses();
  }, []);

  // Fetch payment plans from global master
  useEffect(() => {
    const fetchPaymentPlans = async () => {
      try {
        const base = process.env.REACT_APP_API_BASE_URL;
        const token = localStorage.getItem('token');
        const response = await fetch(
          `${base}/api/globalMasterDetails?type=paymentplan`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          },
        );
        const result = await response.json();
        if (result.success && Array.isArray(result.data)) {
          // Only show active (status: true) and non-deleted plans
          const plans = result.data
            .filter((item) => item.status && !item.isDeleted)
            .map((item) => ({
              id: item._id,
              name: item.details?.planName || '',
            }));
          setPaymentPlans(plans);
        }
      } catch (err) {
        console.error('Error fetching payment plans:', err);
      }
    };
    fetchPaymentPlans();
  }, []);

  const handleOpenExportMenu = (event) =>
    setExportAnchorEl(event.currentTarget);
  const handleCloseExportMenu = () => setExportAnchorEl(null);
  const getExportRows = () => {
    // Export current filtered dataset (not limited to current page)
    // Note: For full export, you may want to fetch all data without pagination
    const rows = displayData;
    return rows.map((b) => ({
      bookingId: b.bookingId,
      plotBookingDate: b.plotBookingDate,
      plotNo: b.plotNo,
      branchName: b.branchName,
      paymentPlan: b.paymentPlan,
      customer: b.customer,
      associate: b.associate,
      plotAmount: b.plotAmount,
      discountAmount: b.discountAmount,
      paidAmount: b.paidAmount,
      status: b.status,
    }));
  };

  const exportAsCSV = () => {
    const rows = getExportRows();
    const headers = [
      'Booking ID',
      'Date',
      'Property No',
      'Branch',
      'Payment Plan',
      'Customer',
      'Associate',
      'Property Amount',
      'Discount Amount',
      'Paid Amount',
      'Status',
    ];
    const escapeCSV = (val) => {
      const s = String(val ?? '');
      if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
      return s;
    };
    const csvLines = [headers.join(',')].concat(
      rows.map((r) =>
        [
          escapeCSV(r.bookingId),
          escapeCSV(r.plotBookingDate),
          escapeCSV(r.plotNo),
          escapeCSV(r.branchName),
          escapeCSV(r.paymentPlan),
          escapeCSV(r.customer),
          escapeCSV(r.associate),
          r.plotAmount,
          r.discountAmount,
          r.paidAmount,
          escapeCSV(r.status),
        ].join(','),
      ),
    );
    const blob = new Blob(['\uFEFF' + csvLines.join('\n')], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `bookings_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const exportAsPDF = () => {
    const rows = getExportRows();
    exportPDFUtil({
      rows: rows.map((r) => ({
        'Booking ID': r.bookingId,
        Date: r.plotBookingDate,
        'Property No': r.plotNo,
        Branch: r.branchName,
        'Payment Plan': r.paymentPlan,
        Customer: r.customer,
        Associate: r.associate,
        'Property Amount': r.plotAmount,
        'Discount Amount': r.discountAmount,
        'Paid Amount': r.paidAmount,
        Status: r.status,
      })),
      title: 'Booking Details',
      fileNameBase: 'bookings',
    });
  };

  const exportAsExcelHandler = () => {
    const rows = getExportRows();
    exportAsExcel({
      rows: rows.map((r) => ({
        'Booking ID': r.bookingId,
        Date: r.plotBookingDate,
        'Property No': r.plotNo,
        Branch: r.branchName,
        'Payment Plan': r.paymentPlan,
        Customer: r.customer,
        Associate: r.associate,
        'Property Amount': r.plotAmount,
        'Discount Amount': r.discountAmount,
        'Paid Amount': r.paidAmount,
        Status: r.status,
      })),
      sheetName: 'Bookings',
      fileNameBase: 'bookings',
    });
  };

  const handleExport = (type) => {
    handleCloseExportMenu();
    if (type === 'pdf') {
      setPdfType('list');
      setPdfDialogOpen(true);
    } else if (type === 'csv') {
      exportAsCSV();
    }
  };

  // Booking data from API
  const [bookingData, setBookingData] = useState([]);

  // Update booking when returning from cancellation
  useEffect(() => {
    const cancelledBooking = location.state?.cancelledBooking;
    if (cancelledBooking) {
      setBookingData((prevData) =>
        prevData.map((booking) =>
          booking.bookingId === cancelledBooking.bookingId
            ? {
              ...booking,
              status: 'cancelled',
              cancelDate:
                cancelledBooking.cancelDate ||
                cancelledBooking.cancellationDate,
              cancelReason: cancelledBooking.cancelReason,
              cancellationCharge: cancelledBooking.cancellationCharge,
              refundAmount: cancelledBooking.refundAmount,
              refundMethod: cancelledBooking.refundMethod,
            }
            : booking,
        ),
      );
      // Clear location.state to prevent re-updating on re-render
      history.replace(location.pathname, {});
    }
  }, [location.state, history]);

  // Auto-open booking detail when navigated from dashboard with a bookingId
  useEffect(() => {
    const incomingId = location.state?.bookingId;
    if (!incomingId || bookingData.length === 0) return;

    const match = bookingData.find(
      (b) => b.id === incomingId || b._original?._id === incomingId,
    );
    if (match) {
      handleView(match);
      // Clear state so refresh doesn't re-trigger
      history.replace(location.pathname, { ...location.state, bookingId: undefined });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingData]);

  const handleView = (booking) => {
    setSelectedBooking(booking);
    setViewDialogOpen(true);
    setViewTabValue(0); // Reset to first tab
    setReceipts([]); // Clear previous receipts
  };

  const handleViewDownload = (booking) => {
    setSelectedBooking(booking);
    setReceipts([]); // Clear previous receipts
    setBookingPdfOpen(true);
  };

  // Fetch receipts when Receipt tab is opened
  useEffect(() => {
    const fetchReceipts = async () => {
      if (
        (activeTabLabel === 'Receipt' || activeTabLabel === 'Refund Receipt') &&
        selectedBooking
      ) {
        // Use _id from original data, or fallback to id field
        const bookingId = selectedBooking._original?._id || selectedBooking.id;
        if (!bookingId) {
          setReceiptsError('Booking ID not found');
          return;
        }

        setReceiptsLoading(true);
        setReceiptsError('');
        try {
          // For refund tab, filter by transactionType 'deduct'
          const transactionType =
            activeTabLabel === 'Refund Receipt' ? 'deduct' : null;
          const response = await getBookingTransactions(
            bookingId,
            transactionType,
          );

          if (response.success && Array.isArray(response.data)) {
            setReceipts(response.data);
            // Store bookingInfo for refund data
            if (response.bookingInfo) {
              setRefundBookingInfo(response.bookingInfo);
            }
          } else {
            setReceiptsError('Invalid response format from server');
            setReceipts([]);
          }
        } catch (err) {
          console.error('Error fetching receipts:', err);
          setReceiptsError(err.message || 'Failed to load receipts');
          setReceipts([]);
        } finally {
          setReceiptsLoading(false);
        }
      }
    };

    fetchReceipts();
  }, [viewTabValue, selectedBooking]);

  // Fetch installment plan when Installment tab is opened in view dialog
  useEffect(() => {
    const isInstallmentTab = activeTabLabel === 'Installment';
    const bookingId =
      selectedBooking?._original?._id ||
      selectedBooking?.id ||
      selectedBooking?._id ||
      selectedBooking?.bookingId;

    if (!viewDialogOpen || !isInstallmentTab || !bookingId) {
      setInstallmentPlan(null);
      setInstallmentError('');
      setInstallmentLoading(false);
      return;
    }

    const fetchInstallmentPlan = async () => {
      try {
        setInstallmentLoading(true);
        setInstallmentPlan(null);
        setInstallmentError('');

        const json = await getInstallmentPlan(bookingId);

        if (
          json.status === false &&
          (json.message?.toLowerCase().includes('not found') ||
            json.message
              ?.toLowerCase()
              .includes('installment plan for this booking not found'))
        ) {
          setInstallmentPlan(null);
          return;
        }

        if (
          (json.status || json.success) &&
          json.data &&
          Object.keys(json.data).length > 0
        ) {
          setInstallmentPlan(json.data);
          return;
        }

        if (json.data && Object.keys(json.data).length > 0) {
          setInstallmentPlan(json.data);
        } else {
          setInstallmentPlan(null);
          setInstallmentError('');
        }
      } catch (err) {
        const message = err.message || 'Failed to load installment plan';
        if (message.toLowerCase().includes('not found')) {
          setInstallmentPlan(null);
          setInstallmentError('');
        } else {
          setInstallmentPlan(null);
          setInstallmentError(message);
        }
      } finally {
        setInstallmentLoading(false);
      }
    };

    fetchInstallmentPlan();
  }, [viewDialogOpen, viewTabValue, selectedBooking]);

  // Fetch progress when Progress tab is opened
  useEffect(() => {
    const fetchProgress = async () => {
      if (!selectedBooking) return;

      // Progress tab is at index 6 (or 7 if cancelled)
      // Use the same condition as the Progress tab rendering
      const isProgressTab = activeTabLabel === 'Progress';

      if (isProgressTab) {
        // Use _id from original data, or fallback to id field
        const bookingId = selectedBooking._original?._id || selectedBooking.id;
        if (!bookingId) {
          setProgressError('Booking ID not found');
          setProgressData([]);
          return;
        }

        setProgressLoading(true);
        setProgressError('');

        try {
          const response = await getBookingProgress({
            bookingId: bookingId,
            page: 1,
            limit: 100, // Get all progress items
          });

          // Handle different response formats
          if (
            response.status &&
            response.data &&
            Array.isArray(response.data.docs)
          ) {
            setProgressData(response.data.docs);
          } else if (
            response.success &&
            response.data &&
            Array.isArray(response.data.docs)
          ) {
            setProgressData(response.data.docs);
          } else if (response.data && Array.isArray(response.data.docs)) {
            setProgressData(response.data.docs);
          } else if (Array.isArray(response.data)) {
            setProgressData(response.data);
          } else if (Array.isArray(response)) {
            setProgressData(response);
          } else {
            setProgressData([]);
          }
        } catch (err) {
          console.error('Error fetching progress:', err);
          setProgressError(err.message || 'Failed to load booking progress');
          setProgressData([]);
        } finally {
          setProgressLoading(false);
        }
      }
    };

    fetchProgress();
  }, [viewTabValue, selectedBooking]);

  // Toggle expandable row in grouped view
  const toggleRowExpansion = (rowId) => {
    setExpandedGroupedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // Fetch commissions when Commission tab is opened
  useEffect(() => {
    const isCommissionTab = activeTabLabel === 'Commission';

    const bookingId = selectedBooking?._original?._id || selectedBooking?.id;
    if (!viewDialogOpen || !isCommissionTab || !bookingId) {
      setCommissions([]);
      setCommissionsError('');
      setTotalCommission(0);
      setTotalDistribution(0);
      setIsCommissionTypeFixed(false);
      return;
    }

    const fetchCommissions = async () => {
      try {
        setCommissionsLoading(true);
        setCommissionsError('');

        // Fetch booking hierarchy to get associates list and bookingCommissionTypeFixed
        let isFixed = Boolean(
          selectedBooking?.bookingCommissionTypeFixed ||
          selectedBooking?._original?.bookingCommissionTypeFixed
        );

        const hierarchyRes = await getBookingHierarchy(bookingId).catch(() => null);
        if (hierarchyRes?.success && hierarchyRes?.data) {
          if (Array.isArray(hierarchyRes.data.associates)) {
            setAssociatesList(hierarchyRes.data.associates);
          }
          if (hierarchyRes.data.booking?.bookingCommissionTypeFixed !== undefined) {
            isFixed = Boolean(hierarchyRes.data.booking.bookingCommissionTypeFixed);
          }
          if (hierarchyRes.data.booking?.fixedCommissionRemark) {
            setFixedCommissionRemark(String(hierarchyRes.data.booking.fixedCommissionRemark));
          }
        }
        setIsCommissionTypeFixed(isFixed);

        const associateId = commissionsAssociateFilter?._id || commissionsAssociateFilter?.associateId || '';

        let response;
        if (commissionViewMode === 'grouped') {
          response = await getGroupedCommissionReports({ bookingId, associateId });
        } else {
          response = await getCommissionGenerator({ bookingId, associateId });
        }

        if (response.success || response.status === true) {
          const list = Array.isArray(response.data) ? response.data : [];
          setCommissions(list);
          setTotalCommission(response.totalPayableCommissionAmount || 0);
          setTotalDistribution(response.totalDistributionAmount || 0);

          if (!isFixed && list.some((r) => Boolean(r.bookingCommissionTypeFixed))) {
            setIsCommissionTypeFixed(true);
          }

          // Extract fixedCommissionRemark if present in API response
          const summary = response.bookingCommissionSummary || response.data?.bookingCommissionSummary || {};
          const remarkFromApi = response.fixedCommissionRemark || summary.fixedCommissionRemark || (response.data && !Array.isArray(response.data) ? response.data.fixedCommissionRemark : '') || selectedBooking?.fixedCommissionRemark || selectedBooking?._original?.fixedCommissionRemark || '';

          if (remarkFromApi) {
            setFixedCommissionRemark(String(remarkFromApi));
          }
        } else {
          throw new Error(response.message || 'Failed to load commissions');
        }
      } catch (err) {
        setCommissions([]);
        setTotalCommission(0);
        setTotalDistribution(0);
        setCommissionsError(err.message || 'Failed to load commissions');
      } finally {
        setCommissionsLoading(false);
      }
    };

    fetchCommissions();
  }, [viewDialogOpen, viewTabValue, selectedBooking, commissionViewMode, commissionsAssociateFilter]);

  const handleFollowUpFormChange = (field, value) => {
    setFollowUpForm((prev) => ({ ...prev, [field]: value }));
    if (followUpSaveError) setFollowUpSaveError('');
    if (followUpSaveSuccess) setFollowUpSaveSuccess('');
  };

  const handleSaveFollowUp = async () => {
    if (!followUpForm.remark) {
      setFollowUpSaveError('Please enter a remark');
      return;
    }
    if (!followUpForm.status) {
      setFollowUpSaveError('Please select a status');
      return;
    }

    try {
      setSavingFollowUp(true);
      setFollowUpSaveError('');

      const bookingId = selectedBooking?._original?._id || selectedBooking?.id;
      const payload = {
        bookingId,
        followUpDate: followUpForm.date,
        nextFollowUpDate: followUpForm.nextFollowUpDate,
        status: followUpForm.status,
        remark: followUpForm.remark,
        description: followUpForm.remark,
      };

      await createBookingFollowUp(payload);

      setFollowUpSaveSuccess('Follow-up saved successfully!');
      setFollowUpForm({
        date: new Date().toISOString(),
        nextFollowUpDate: '',
        status: '',
        remark: '',
      });

      // Refresh follow-ups list
      if (bookingId) {
        const response = await getBookingFollowUps({
          bookingId: bookingId,
          page: 1,
          limit: 100,
        });
        if (response.status || response.success) {
          const followUpData = response.data;
          if (Array.isArray(followUpData)) {
            setFollowUps(followUpData);
          } else if (followUpData && Array.isArray(followUpData.docs)) {
            setFollowUps(followUpData.docs);
          }
        }
      }
    } catch (err) {
      console.error('Error saving follow-up:', err);
      setFollowUpSaveError(err.message || 'Failed to save follow-up');
    } finally {
      setSavingFollowUp(false);
    }
  };

  // Fetch follow-ups when Followup/Remark tab is opened
  useEffect(() => {
    const isFollowUpTab = activeTabLabel === 'Followup/Remark';

    const bookingId = selectedBooking?._original?._id || selectedBooking?.id;
    if (!viewDialogOpen || !isFollowUpTab || !bookingId) {
      setFollowUps([]);
      setFollowUpsError('');
      return;
    }

    const fetchFollowUps = async () => {
      try {
        setFollowUpsLoading(true);
        setFollowUpsError('');

        const response = await getBookingFollowUps({
          bookingId: bookingId,
          page: followUpsPage + 1,
          limit: followUpsRowsPerPage,
        });

        // Map response correctly: handle both paginated (docs) and simple array structures
        if (response.status || response.success) {
          const followUpData = response.data;
          if (Array.isArray(followUpData)) {
            setFollowUps(followUpData);
            setFollowUpsTotalCount(followUpData.length);
          } else if (followUpData && Array.isArray(followUpData.docs)) {
            setFollowUps(followUpData.docs);
            setFollowUpsTotalCount(
              followUpData.totalDocs ||
              followUpData.total ||
              followUpData.count ||
              followUpData.docs.length,
            );
          } else {
            setFollowUps([]);
            setFollowUpsTotalCount(0);
          }
        } else {
          setFollowUps([]);
          setFollowUpsTotalCount(0);
        }
      } catch (err) {
        console.error('Error fetching follow-ups:', err);
        setFollowUpsError(err.message || 'Failed to load follow-ups');
        setFollowUps([]);
        setFollowUpsTotalCount(0);
      } finally {
        setFollowUpsLoading(false);
      }
    };

    fetchFollowUps();
  }, [
    viewDialogOpen,
    viewTabValue,
    selectedBooking,
    followUpsPage,
    followUpsRowsPerPage,
  ]);

  // Helper function to get refund transactions from receipts
  const getRefundTransactions = () => {
    if (!receipts || receipts.length === 0) return [];
    return receipts.filter(
      (receipt) =>
        receipt.receivedType === 'bookingRefundAmount' ||
        receipt.transactionType === 'deduct',
    );
  };

  // Helper function to get refund summary
  const getRefundSummary = () => {
    const refundTransactions = getRefundTransactions();

    // Get amounts from booking info
    const totalRefundAmount = refundBookingInfo?.totalRefundAmount || 0;
    const refundedAmount = refundBookingInfo?.refundedAmount || 0;

    // Calculate pending: totalRefundAmount - refundedAmount
    const pending = Math.max(0, totalRefundAmount - refundedAmount);

    // If we have booking info with refund data
    if (refundBookingInfo && (totalRefundAmount > 0 || refundedAmount > 0)) {
      return {
        total: totalRefundAmount,
        processed: refundedAmount, // Amount actually refunded to customer
        pending: pending, // Amount still to be refunded
        count: refundTransactions.length || (refundedAmount > 0 ? 1 : 0),
        processedCount: refundedAmount > 0 ? 1 : 0,
        pendingCount: pending > 0 ? 1 : 0,
        fromBookingInfo: refundTransactions.length === 0,
        cancellationDetails: {
          chargeAmount: refundBookingInfo.cancellationChargeAmount || 0,
          chargePercent: refundBookingInfo.cancellationChargePercent || 0,
          method: refundBookingInfo.refundMethod || '',
          reason: refundBookingInfo.cancellationReason || '',
          cancelledBy: refundBookingInfo.cancelledBy || '',
          cancelledAt: refundBookingInfo.cancelledAt || '',
        },
      };
    }

    // No refund data available
    return {
      total: 0,
      processed: 0,
      pending: 0,
      count: 0,
      processedCount: 0,
      pendingCount: 0,
      fromBookingInfo: false,
      cancellationDetails: null,
    };
  };

  // Fetch documents when Document tab is opened
  useEffect(() => {
    const isDocumentTab = activeTabLabel === 'Document';

    const bookingId = selectedBooking?._original?._id || selectedBooking?.id;
    if (!viewDialogOpen || !isDocumentTab || !bookingId) {
      setDocuments([]);
      setDocumentsError('');
      return;
    }

    const fetchDocuments = async () => {
      try {
        setDocumentsLoading(true);
        setDocumentsError('');

        const response = await getBookingDocuments(bookingId);

        // Extract documents from response
        if (
          response.success &&
          response.data &&
          Array.isArray(response.data.documents)
        ) {
          setDocuments(response.data.documents);
        } else {
          setDocuments([]);
        }
      } catch (err) {
        console.error('Error fetching documents:', err);
        setDocumentsError(err.message || 'Failed to load documents');
        setDocuments([]);
      } finally {
        setDocumentsLoading(false);
      }
    };

    fetchDocuments();
  }, [viewDialogOpen, viewTabValue, selectedBooking]);

  const handleCloseViewDialog = () => {
    setViewDialogOpen(false);
    setSelectedBooking(null);
    setViewTabValue(0);
  };

  const handleEdit = (booking) => {
    // Pass the full booking object including _original API data
    history.push(`/app/booking/BookingDetails/${booking.id}`, {
      bookingData: booking,
    });
  };

  const handleCancel = (booking) => {
    history.push('/app/plotbooking/CancleBooking', { booking });
  };

  const handleUpload = (booking) => {
    alert(`Upload documents for booking: ${booking.bookingId}`);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when changing rows per page
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPage(0); // Reset to first page when changing tabs
  };

  const handleClearFilters = () => {
    setFilterBranch('all');
    setFilterFromDate('');
    setFilterToDate('');
    setFilterMinAmount('');
    setFilterMaxAmount('');
  };

  const handleResetAll = () => {
    setSearchQuery('');
    setPaymentPlanFilter('all');
    handleClearFilters();
    setPage(0);
  };

  const removeFilter = (key) => {
    if (key === 'filterBranch') setFilterBranch('all');
    else if (key === 'filterFromDate') setFilterFromDate('');
    else if (key === 'filterToDate') setFilterToDate('');
    else if (key === 'filterMinAmount') setFilterMinAmount('');
    else if (key === 'filterMaxAmount') setFilterMaxAmount('');
  };

  // Refund dialog handlers
  const handleOpenRefundDialog = () => {
    setRefundDialogOpen(true);
    setRefundFormData({
      ...refundFormData,
      bookingId:
        selectedBooking?._original?._id ||
        selectedBooking?.id ||
        selectedBooking?._id ||
        '',
    });
  };

  const handleCloseRefundDialog = () => {
    setRefundDialogOpen(false);
    setRefundFormData({
      bookingId: '',
      amount: '',
      receivedDate: '',
      paymentType: 'partialPayment',
      mode: '',
      refNo: '',
      bankName: '',
      otherRemark: '',
    });
  };

  const handleRefundFormChange = (field, value) => {
    setRefundFormData({
      ...refundFormData,
      [field]: value,
    });
  };

  const handleCreateRefundReceipt = async () => {
    // Validate required fields
    if (!refundFormData.amount || parseFloat(refundFormData.amount) <= 0) {
      setSnackbarMessage('Please enter a valid refund amount');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    if (!refundFormData.receivedDate) {
      setSnackbarMessage('Please select a refund date');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    // Validate refund amount does not exceed pending amount
    const refundSummary = getRefundSummary();
    const enteredAmount = parseFloat(refundFormData.amount);

    if (enteredAmount > refundSummary.pending) {
      setSnackbarMessage(
        `Refund amount (₹${enteredAmount.toLocaleString('en-IN')}) cannot be greater than pending amount (₹${refundSummary.pending.toLocaleString('en-IN')})`,
      );
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    setCreatingRefund(true);
    try {
      const payload = {
        bookingId: refundFormData.bookingId,
        amount: parseFloat(refundFormData.amount),
        receivedDate: refundFormData.receivedDate,
        receivedType: 'bookingRefundAmount',
        transactionType: 'deduct',
        paymentType: refundFormData.paymentType,
        mode: refundFormData.mode || 'cash',
        refNo: refundFormData.refNo || '',
        bankName: refundFormData.bankName || '',
        otherRemark: refundFormData.otherRemark || '',
        createdBy: 'admin',
        updatedBy: 'admin',
      };

      const response = await createRefundReceipt(payload);

      if (response.success) {
        setSnackbarMessage('Refund receipt created successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        handleCloseRefundDialog();

        // Refresh the receipts data with transactionType filter
        if (selectedBooking) {
          const bookingId =
            selectedBooking._original?._id || selectedBooking.id;
          if (bookingId) {
            const refreshResponse = await getBookingTransactions(
              bookingId,
              'deduct',
            );
            if (
              refreshResponse.success &&
              Array.isArray(refreshResponse.data)
            ) {
              setReceipts(refreshResponse.data);
              if (refreshResponse.bookingInfo) {
                setRefundBookingInfo(refreshResponse.bookingInfo);
              }
            }
          }
        }
      } else {
        setSnackbarMessage(
          response.message || 'Failed to create refund receipt',
        );
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error creating refund receipt:', error);
      setSnackbarMessage(error.message || 'Failed to create refund receipt');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setCreatingRefund(false);
    }
  };

  // Client-side filtering for additional filters (branch, date range, amount range)
  // Status and payment plan filtering is now done by API
  const filteredData = bookingData.filter((booking) => {
    // Branch filter
    if (filterBranch !== 'all' && booking.branchName !== filterBranch)
      return false;
    // Date range filter
    if (filterFromDate && booking.plotBookingDate < filterFromDate)
      return false;
    if (filterToDate && booking.plotBookingDate > filterToDate) return false;
    // Amount range filter (using plotAmount)
    if (filterMinAmount && booking.plotAmount < Number(filterMinAmount))
      return false;
    if (filterMaxAmount && booking.plotAmount > Number(filterMaxAmount))
      return false;
    return true;
  });

  // Status filtering is now done by API, so displayData is just the filtered data
  const displayData = filteredData;

  // Note: Counts are now based on current page data only
  // For accurate counts, you would need separate API calls or include counts in response
  const bookedCount = bookingData.filter(
    (booking) => booking.status === 'booked' || booking.status === 'pending',
  ).length;
  const allotedCount = bookingData.filter(
    (booking) => booking.status === 'alloted',
  ).length;
  const cancelledCount = bookingData.filter(
    (booking) => booking.status === 'cancelled',
  ).length;

  // Calculate statistics (based on current page data)
  const totalRevenue = bookingData.reduce((sum, b) => sum + b.plotAmount, 0);
  const totalPaid = bookingData.reduce((sum, b) => sum + b.paidAmount, 0);
  const totalPending = totalRevenue - totalPaid;

  // Pagination is now handled by API, so use data directly
  const paginatedData = displayData;

  const formatDate = (value) => {
    if (!value) return '';
    try {
      return new Date(value).toISOString().split('T')[0];
    } catch (error) {
      return '';
    }
  };

  const getPaymentProgress = (paid, total) => {
    return (paid / total) * 100;
  };

  const renderInstallmentContent = () => {
    if (installmentLoading) {
      return (
        <Box sx={{ py: 4, textAlign: 'center' }}>
          <CircularProgress size={24} />
          <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
            Loading installment plan...
          </Typography>
        </Box>
      );
    }

    if (installmentError) {
      return (
        <Alert severity='error' sx={{ mb: 2 }}>
          {installmentError}
        </Alert>
      );
    }

    if (!installmentPlan) {
      return (
        <Paper sx={{ p: 3, textAlign: 'center', bgcolor: '#f8f9fa' }}>
          <Typography variant='body2' color='text.secondary'>
            No installment plan found for this booking.
          </Typography>
        </Paper>
      );
    }

    const schedule = Array.isArray(installmentPlan.schedule)
      ? [...installmentPlan.schedule].sort(
        (a, b) => (a.srNo || 0) - (b.srNo || 0),
      )
      : [];

    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, bgcolor: '#f8f9fa', mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label='Total Due'
                  type='number'
                  value={installmentPlan.totalDue ?? ''}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>₹</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label='Number of Installments'
                  type='number'
                  value={installmentPlan.numberOfInstallments ?? ''}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label='Installment Amount'
                  type='number'
                  value={installmentPlan.installmentAmount ?? ''}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>₹</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label='Start Date'
                  type='date'
                  value={formatDate(installmentPlan.startDate)}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label='Frequency'
                  value={installmentPlan.frequency || ''}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label='Plan Status'
                  value={(installmentPlan.planStatus || 'ACTIVE').toUpperCase()}
                  disabled
                />
              </Grid>
            </Grid>
          </Paper>

          <TableContainer component={Paper} variant='outlined'>
            <Table size='small'>
              <TableHead>
                <TableRow sx={{ bgcolor: '#fafafa' }}>
                  <TableCell>
                    <strong>Sr No.</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Due Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Amount</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Paid Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Status</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {schedule.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align='center' sx={{ py: 3 }}>
                      <Typography variant='body2' color='text.secondary'>
                        No installments scheduled for this booking.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  schedule.map((inst) => {
                    const dueDate = formatDate(inst.dueDate) || '-';
                    const paidDate = inst.paidDate
                      ? formatDate(inst.paidDate)
                      : '-';
                    const status = inst.status || 'PENDING';

                    return (
                      <TableRow
                        key={inst.srNo || `${inst.dueDate}-${inst.amount}`}
                      >
                        <TableCell>{inst.srNo || '-'}</TableCell>
                        <TableCell>{dueDate || '-'}</TableCell>
                        <TableCell>
                          ₹{(inst.amount ?? 0).toLocaleString('en-IN')}
                        </TableCell>
                        <TableCell>{paidDate}</TableCell>
                        <TableCell>
                          <Chip
                            label={status}
                            size='small'
                            color={
                              status === 'PAID'
                                ? 'success'
                                : status === 'OVERDUE'
                                  ? 'error'
                                  : 'warning'
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    );
  };

  if (!canReadBooking) {
    return (
      <Box
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{ p: 5, textAlign: 'center', borderRadius: 4, maxWidth: 500 }}
        >
          <Avatar
            sx={{
              bgcolor: '#fee2e2',
              color: '#ef4444',
              width: 80,
              height: 80,
              mb: 3,
              mx: 'auto',
            }}
          >
            <WarningAmber sx={{ fontSize: 50 }} />
          </Avatar>
          <Typography
            variant='h4'
            fontWeight='bold'
            color='#1a202c'
            gutterBottom
          >
            Access Denied
          </Typography>
          <Typography
            variant='body1'
            color='text.secondary'
            sx={{ mb: 4, fontSize: '1.1rem' }}
          >
            You do not have permission to view this module. Please contact your
            administrator if you believe this is an error.
          </Typography>
          <Button
            variant='contained'
            onClick={() => history.push('/app/dashboard')}
            sx={{
              backgroundColor: '#536DFE',
              '&:hover': { backgroundColor: '#3d5afe' },
              borderRadius: 2,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 'bold',
            }}
          >
            Back to Dashboard
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 1 }}>
      {/* <Loader open={loading} message="Loading bookings..." /> */}
      {/* Modern Header Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          mb: 4,
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar sx={{ width: 56, height: 56, bgcolor: '#536DFE' }}>
            <Receipt sx={{ fontSize: 32 }} />
          </Avatar>
          <Box>
            <Typography
              variant='h4'
              fontWeight='bold'
              color='primary'
              sx={{ fontSize: { xs: '1rem', md: '1.125rem' } }}
            >
              Booking Management
            </Typography>
            {/* <img src="https://.com/logoonly.png" alt="Logo" /> */}
            <Typography variant='body2' color='text.secondary'>
              Track and manage all bookings • {displayData.length} records
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            width: { xs: '100%', md: 'auto' },
            justifyContent: { xs: 'flex-start', md: 'flex-end' },
            alignItems: 'center',
          }}
        >
          {canWriteBooking && (
            <ExportButton
              onExportPdf={exportAsPDF}
              onExportCsv={exportAsCSV}
              onExportExcel={exportAsExcelHandler}
              variant='contained'
            />
          )}
          <RefreshButton
            onClick={fetchBookings}
            loading={loading}
            sx={{
              fontWeight: 600,
              px: 2,
              fontSize: '14px',
              borderRadius: 2,
              height: { xs: 'auto', sm: 36 },
            }}
          />
        </Box>
      </Box>

      {/* Statistics Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
                    borderRadius: 2,
            boxShadow: 1,
            border: '1px solid #e0e0e0'
          }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Bookings</Typography>
                  <Typography variant="h4" fontWeight="bold" color="text.primary">
                    {bookingData.length}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">All time</Typography>
                </Box>
                <Receipt sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.2 }} />
        </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
                    borderRadius: 2,
            boxShadow: 1,
            border: '1px solid #e0e0e0'
          }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Booked (Pending)</Typography>
                  <Typography variant="h4" fontWeight="bold" color="text.primary">
                    {bookedCount}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">In progress</Typography>
                </Box>
                <Pending sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.2 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
                    borderRadius: 2,
            boxShadow: 1,
            border: '1px solid #e0e0e0'
          }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Alloted (Complete)</Typography>
                  <Typography variant="h4" fontWeight="bold" color="text.primary">
                    {allotedCount}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">Completed</Typography>
                </Box>
                <CheckCircle sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.2 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            borderRadius: 2, 
            boxShadow: 1,
            border: '1px solid #e0e0e0'
          }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Revenue</Typography>
                  <Typography variant="h5" fontWeight="bold" color="text.primary">
                    ₹{(totalRevenue / 10000000).toFixed(2)}Cr
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    ₹{(totalPaid / 100000).toFixed(1)}L collected
          </Typography>
                </Box>
                <AttachMoney sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.2 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search and Filters Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder='Search by Booking ID, Internal ID, Customer, Plot...'
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPage(0); // Reset to first page when search changes
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <Search color='primary' />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Payment Plan</InputLabel>
              <Select
                value={paymentPlanFilter}
                onChange={(e) => {
                  setPaymentPlanFilter(e.target.value);
                  setPage(0); // Reset to first page when filter changes
                }}
                label='Payment Plan'
              >
                <MenuItem value='all'>All Payment Plans</MenuItem>
                {paymentPlans.map((plan) => (
                  <MenuItem key={plan.id} value={plan.name}>
                    {plan.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                fullWidth
                variant={
                  filterBranch !== 'all' ||
                    filterFromDate ||
                    filterToDate ||
                    filterMinAmount ||
                    filterMaxAmount
                    ? 'contained'
                    : 'outlined'
                }
                startIcon={<FilterList />}
                sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                onClick={() => setMoreFiltersOpen(true)}
                color={
                  filterBranch !== 'all' ||
                    filterFromDate ||
                    filterToDate ||
                    filterMinAmount ||
                    filterMaxAmount
                    ? 'primary'
                    : 'inherit'
                }
              >
                More Filters
                {(filterBranch !== 'all' ||
                  filterFromDate ||
                  filterToDate ||
                  filterMinAmount ||
                  filterMaxAmount) &&
                  ` (${[filterBranch !== 'all', !!filterFromDate, !!filterToDate, !!filterMinAmount, !!filterMaxAmount].filter(Boolean).length})`}
              </Button>
              <Button
                variant='outlined'
                startIcon={<Refresh />}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  minWidth: 'fit-content',
                }}
                onClick={handleResetAll}
                color='inherit'
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
        {/* Active Filter Chips */}
        {(filterBranch !== 'all' ||
          filterFromDate ||
          filterToDate ||
          filterMinAmount ||
          filterMaxAmount) && (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                mt: 2,
                pt: 2,
                borderTop: '1px solid #f0f0f0',
              }}
            >
              <Typography
                variant='caption'
                sx={{
                  alignSelf: 'center',
                  mr: 1,
                  fontWeight: 700,
                  color: 'text.secondary',
                }}
              >
                ACTIVE FILTERS:
              </Typography>
              {filterBranch !== 'all' && (
                <Chip
                  label={`Branch: ${filterBranch}`}
                  size='small'
                  onDelete={() => removeFilter('filterBranch')}
                  color='primary'
                  variant='outlined'
                />
              )}
              {filterFromDate && (
                <Chip
                  label={`From: ${filterFromDate}`}
                  size='small'
                  onDelete={() => removeFilter('filterFromDate')}
                  color='primary'
                  variant='outlined'
                />
              )}
              {filterToDate && (
                <Chip
                  label={`To: ${filterToDate}`}
                  size='small'
                  onDelete={() => removeFilter('filterToDate')}
                  color='primary'
                  variant='outlined'
                />
              )}
              {filterMinAmount && (
                <Chip
                  label={`Min: ₹${filterMinAmount}`}
                  size='small'
                  onDelete={() => removeFilter('filterMinAmount')}
                  color='primary'
                  variant='outlined'
                />
              )}
              {filterMaxAmount && (
                <Chip
                  label={`Max: ₹${filterMaxAmount}`}
                  size='small'
                  onDelete={() => removeFilter('filterMaxAmount')}
                  color='primary'
                  variant='outlined'
                />
              )}
              <Button
                size='small'
                variant='text'
                onClick={handleClearFilters}
                sx={{ fontSize: '0.75rem', fontWeight: 700 }}
              >
                CLEAR ALL
              </Button>
            </Box>
          )}
      </Paper>

      {/* More Filters Dialog */}
      <Dialog
        open={moreFiltersOpen}
        onClose={() => setMoreFiltersOpen(false)}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>More Filters</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Branch</InputLabel>
                <Select
                  label='Branch'
                  value={filterBranch}
                  onChange={(e) => setFilterBranch(e.target.value)}
                >
                  <MenuItem value='all'>All Branches</MenuItem>
                  {[...new Set(bookingData.map((b) => b.branchName))].map(
                    (b) => (
                      <MenuItem key={b} value={b}>
                        {b}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label='Min Property Amount (₹)'
                type='number'
                value={filterMinAmount}
                onChange={(e) => setFilterMinAmount(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label='From Date'
                type='date'
                InputLabelProps={{ shrink: true }}
                value={filterFromDate}
                onChange={(e) => setFilterFromDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label='Max Property Amount (₹)'
                type='number'
                value={filterMaxAmount}
                onChange={(e) => setFilterMaxAmount(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label='To Date'
                type='date'
                InputLabelProps={{ shrink: true }}
                value={filterToDate}
                onChange={(e) => setFilterToDate(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleClearFilters}
            color='inherit'
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Reset Fields
          </Button>
          <Box sx={{ flex: 1 }} />
          <Button
            onClick={() => setMoreFiltersOpen(false)}
            color='inherit'
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            onClick={() => setMoreFiltersOpen(false)}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tabs and Table */}
      <Paper sx={{ borderRadius: 3, boxShadow: 3, overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'white' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.9375rem',
                minHeight: 56,
                px: 6,
              },
            }}
          >
            <Tab
              label={
                <Badge
                  // badgeContent={bookingData.length}
                  color='primary'
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -12,
                      top: 2,
                    },
                  }}
                >
                  All Bookings
                </Badge>
              }
            />
            <Tab
              label={
                <Badge
                  // badgeContent={bookedCount}
                  color='primary'
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -12,
                      top: 2,
                    },
                  }}
                >
                  Booked
                </Badge>
              }
            />

            <Tab
              label={
                <Badge
                  // badgeContent={registryCount}
                  color='primary'
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -12,
                      top: 2,
                    },
                  }}
                >
                  Registry
                </Badge>
              }
            />
            <Tab
              label={
                <Badge
                  // badgeContent={allotedCount}
                  color='primary'
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -12,
                      top: 2,
                    },
                  }}
                >
                  Pending
                </Badge>
              }
            />
            <Tab
              label={
                <Badge
                  // badgeContent={cancelledCount}
                  color='error'
                  sx={{
                    '& .MuiBadge-badge': {
                      right: -12,
                      top: 2,
                    },
                  }}
                >
                  Cancelled
                </Badge>
              }
            />
          </Tabs>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#fafafa' }}>
                <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>
                  Booking ID
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>
                  Customer
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>
                  Property Info
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>
                  Payment Plan
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>
                  Financial Status
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>
                  Status
                </TableCell>
                <TableCell
                  align='center'
                  sx={{ fontWeight: 700, color: 'text.primary' }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7} align='center' sx={{ py: 8 }}>
                    <CircularProgress />
                    <Typography
                      variant='body2'
                      color='text.secondary'
                      sx={{ mt: 2 }}
                    >
                      Loading bookings...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : error ? (
                <TableRow>
                  <TableCell colSpan={7} align='center' sx={{ py: 8 }}>
                    <Alert severity='error' sx={{ mb: 2 }}>
                      {error}
                    </Alert>
                    <Button
                      variant='outlined'
                      startIcon={<Refresh />}
                      onClick={fetchBookings}
                    >
                      Retry
                    </Button>
                  </TableCell>
                </TableRow>
              ) : paginatedData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align='center' sx={{ py: 8 }}>
                    <Typography variant='body2' color='text.secondary'>
                      No bookings found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((booking) => {
                  const progress = getPaymentProgress(
                    booking.paidAmount,
                    booking.plotAmount,
                  );
                  return (
                    <TableRow
                      key={booking.id}
                      sx={{
                        '&:hover': {
                          backgroundColor: 'rgba(83, 109, 254, 0.04)',
                          transform: 'scale(1.001)',
                          transition: 'all 0.2s',
                        },
                      }}
                    >
                      <TableCell>
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          <Avatar
                            sx={{
                              width: 32,
                              height: 32,
                              bgcolor: 'primary.main',
                              fontSize: '0.875rem',
                            }}
                          >
                            {booking.bookingId
                              ? booking.bookingId.slice(-2)
                              : 'BK'}
                          </Avatar>
                          <Box>
                            <Typography variant='body2' fontWeight='700'>
                              {booking.bookingId}
                            </Typography>
                            <Typography
                              variant='caption'
                              color='text.secondary'
                            >
                              <CalendarToday
                                sx={{
                                  fontSize: 12,
                                  mr: 0.5,
                                  verticalAlign: 'middle',
                                }}
                              />
                              {booking.plotBookingDate}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box>
                          <Typography variant='body2' fontWeight='600'>
                            <Person
                              sx={{
                                fontSize: 16,
                                mr: 0.5,
                                verticalAlign: 'middle',
                                color: 'primary.main',
                              }}
                            />
                            {booking.customer}
                          </Typography>
                          <Typography variant='caption' color='text.secondary'>
                            Associate: {booking.associate}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box>
                          <Typography variant='body2' fontWeight='600'>
                            <Home
                              sx={{
                                fontSize: 16,
                                mr: 0.5,
                                verticalAlign: 'middle',
                                color: 'text.secondary',
                              }}
                            />
                            {booking.inventoryType} {booking.plotNo}
                          </Typography>
                          <Typography variant='caption' color='text.secondary'>
                            <Business
                              sx={{
                                fontSize: 12,
                                mr: 0.5,
                                verticalAlign: 'middle',
                              }}
                            />
                            {booking.branchName}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={booking.paymentPlan}
                          size='small'
                          variant='outlined'
                          color={
                            booking.paymentPlan === 'EMI'
                              ? 'primary'
                              : 'primary'
                          }
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>

                      <TableCell>
                        <Box sx={{ width: 200 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              mb: 0.5,
                            }}
                          >
                            <Typography variant='caption' fontWeight='600'>
                              ₹{booking.paidAmount.toLocaleString('en-IN')}
                            </Typography>
                            <Typography variant='caption' fontWeight='600'>
                              {progress.toFixed(0)}%
                            </Typography>
                          </Box>
                          <LinearProgress
                            variant='determinate'
                            value={progress}
                            color='primary'
                            sx={{
                              height: 6,
                              borderRadius: 3,
                            }}
                          />
                          <Typography
                            variant='caption'
                            color='text.secondary'
                            sx={{ mt: 0.5, display: 'block' }}
                          >
                            Total: ₹{booking.plotAmount.toLocaleString('en-IN')}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={booking.status.toUpperCase()}
                          size='small'
                          color={
                            booking.status === 'cancelled'
                              ? 'error'
                              : booking.status === 'registry'
                                ? 'success'
                                : booking.status === 'booked' ||
                                  booking.status === 'pending'
                                  ? 'primary'
                                  : 'default'
                          }
                          sx={{ fontWeight: 700 }}
                        />
                      </TableCell>

                      <TableCell align='center'>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 0.5,
                            justifyContent: 'center',
                          }}
                        >
                          {canWriteBooking &&
                            booking.status !== 'pending' &&
                            booking.status !== 'cancelled' && (
                              <Tooltip title='Edit Booking'>
                                <IconButton
                                  size='small'
                                  onClick={() => handleEdit(booking)}
                                  sx={{
                                    color: 'primary.main',
                                    '&:hover': {
                                      backgroundColor:
                                        'rgba(83, 109, 254, 0.1)',
                                      transform: 'scale(1.1)',
                                    },
                                  }}
                                >
                                  <Edit fontSize='small' />
                                </IconButton>
                              </Tooltip>
                            )}
                          <Tooltip title='View Details'>
                            <IconButton
                              size='small'
                              onClick={() => handleView(booking)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'rgba(33, 150, 243, 0.1)',
                                  transform: 'scale(1.1)',
                                },
                              }}
                            >
                              <Visibility fontSize='small' />
                            </IconButton>
                          </Tooltip>
                          {booking.status !== 'cancelled' &&
                            booking.receiptStatus?.toLowerCase().trim() !==
                            'pending' && (
                              <>
                                <Tooltip title='Download Booking Form'>
                                  <IconButton
                                    size='small'
                                    // onClick={() => handleUpload(booking)}
                                    onClick={() => handleViewDownload(booking)}
                                    sx={{
                                      color: 'text.secondary',
                                      '&:hover': {
                                        backgroundColor:
                                          'rgba(76, 175, 80, 0.1)',
                                        transform: 'scale(1.1)',
                                      },
                                    }}
                                  >
                                    <Download fontSize='small' />
                                  </IconButton>
                                </Tooltip>
                                {canWriteBooking && canCancelBooking && (
                                  <Tooltip title='Cancel'>
                                    <IconButton
                                      size='small'
                                      onClick={() => handleCancel(booking)}
                                      sx={{
                                        color: 'text.secondary',
                                        '&:hover': {
                                          backgroundColor:
                                            'rgba(244, 67, 54, 0.1)',
                                          transform: 'scale(1.1)',
                                        },
                                      }}
                                    >
                                      <Cancel fontSize='small' />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </>
                            )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component='div'
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ borderTop: '1px solid #e0e0e0' }}
        />
      </Paper>

      {/* View Booking Dialog (Read-Only with All Tabs) */}
      <Dialog
        open={viewDialogOpen}
        onClose={handleCloseViewDialog}
        maxWidth='lg'
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, height: '90vh' },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: 'primary.main',
            color: 'white',
            py: 3,
          }}
        >
          <Box display='flex' alignItems='center' gap={2}>
            <Avatar
              sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}
            >
              <Visibility sx={{ fontSize: 28 }} />
            </Avatar>
            <Box>
              <Typography variant='h5' fontWeight='bold'>
                View Booking
              </Typography>
              <Typography variant='body2' sx={{ opacity: 0.9 }}>
                {selectedBooking?.bookingId} - {selectedBooking?.customer}
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'white' }}>
          <Tabs
            value={viewTabValue}
            onChange={(e, newValue) => setViewTabValue(newValue)}
            variant='scrollable'
            scrollButtons='auto'
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                minHeight: 56,
              },
            }}
          >
            <Tab icon={<Receipt />} iconPosition='start' label='Booking' />
            <Tab
              icon={<AccountBalance />}
              iconPosition='start'
              label='Installment'
            />
            {canViewReceipt && (
              <Tab icon={<Receipt />} iconPosition='start' label='Receipt' />
            )}
            {selectedBooking?.status === 'cancelled' &&
              canViewRefundReceipt && (
                <Tab
                  icon={<MoneyOff />}
                  iconPosition='start'
                  label='Refund Receipt'
                />
              )}
            {canViewDocument && (
              <Tab
                icon={<Description />}
                iconPosition='start'
                label='Document'
              />
            )}
            {canViewFollowup && (
              <Tab
                icon={<Comment />}
                iconPosition='start'
                label='Followup/Remark'
              />
            )}
            {canViewCommission && (
              <Tab
                icon={<MoneyOff />}
                iconPosition='start'
                label='Commission'
              />
            )}
            {canViewProgress && (
              <Tab icon={<Timeline />} iconPosition='start' label='Progress' />
            )}
          </Tabs>
        </Box>

        <DialogContent
          sx={{ p: 4, maxHeight: 'calc(90vh - 240px)', overflow: 'auto' }}
        >
          {selectedBooking && (
            <Box>
              {/* Tab 0: Booking (Read-Only) - Copy from Edit page but with disabled=true */}
              {activeTabLabel === 'Booking' && (
                <Box>
                  {/* Status Banner */}
                  <Paper
                    sx={{
                      p: 2,
                      mb: 3,
                      bgcolor:
                        selectedBooking.status === 'cancelled'
                          ? '#ffebee'
                          : '#f5f5f5',
                      border: `1px solid ${selectedBooking.status === 'cancelled' ? '#f44336' : '#e0e0e0'}`,
                      borderRadius: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        mb: 1,
                      }}
                    >
                      <Chip
                        label={selectedBooking.status.toUpperCase()}
                        color={
                          selectedBooking.status === 'cancelled'
                            ? 'error'
                            : selectedBooking.status === 'registry'
                              ? 'success'
                              : selectedBooking.status === 'booked' ||
                                selectedBooking.status === 'pending'
                                ? 'primary'
                                : 'default'
                        }
                        sx={{ fontWeight: 700, fontSize: '0.875rem' }}
                      />
                      <Typography
                        variant='h6'
                        fontWeight='bold'
                        color='text.primary'
                      >
                        Booking Status
                      </Typography>
                    </Box>
                    <Typography variant='body2' color='text.secondary'>
                      Booking Date: {selectedBooking.plotBookingDate}
                    </Typography>
                  </Paper>

                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='primary'
                    gutterBottom
                  >
                    Booking Information
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Booking ID'
                        value={selectedBooking.bookingId}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Booking Date'
                        type='date'
                        defaultValue={selectedBooking.plotBookingDate}
                        disabled
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Customer Name'
                        defaultValue={selectedBooking.customer}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Associate/Agent'
                        defaultValue={selectedBooking.associate}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Property Number'
                        defaultValue={selectedBooking.plotNo}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Branch Location'
                        value={selectedBooking.branchName || ''}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Payment Plan'
                        value={selectedBooking.paymentPlan || ''}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Status'
                        value={selectedBooking.status || ''}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Dimensions (W x L)'
                        value={
                          selectedBooking.plotWidth ||
                            selectedBooking.plotLength
                            ? `${selectedBooking.plotWidth || '0'} x ${selectedBooking.plotLength || '0'} ft`
                            : 'N/A'
                        }
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Area Size'
                        value={
                          selectedBooking.plotArea
                            ? typeof selectedBooking.plotArea === 'number'
                              ? `${selectedBooking.plotArea} sqft`
                              : selectedBooking.plotArea
                            : 'N/A'
                        }
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label='Rate (₹/sq ft)'
                        value={
                          selectedBooking.plotRate
                            ? `₹${Number(selectedBooking.plotRate).toLocaleString('en-IN')}`
                            : 'N/A'
                        }
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Property Amount'
                        value={selectedBooking.plotAmount || 0}
                        disabled
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>₹</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Discount Amount'
                        value={selectedBooking.discountAmount || 0}
                        disabled
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>₹</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Paid Amount'
                        value={selectedBooking.paidAmount || 0}
                        disabled
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>₹</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {(selectedBooking.isAuthorityCharges ||
                      selectedBooking.totalAuthorityCharge > 0) && (
                        <>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label='Authority Name'
                              value={selectedBooking.authorityChargeName || 'N/A'}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label='Total Authority Charge'
                              value={selectedBooking.totalAuthorityCharge || 0}
                              disabled
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position='start'>
                                    ₹
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            {/* Empty grid item for alignment if needed, or added another field */}
                          </Grid>
                        </>
                      )}
                  </Grid>

                  {/* Additional Applicants Section (table layout) */}
                  {(() => {
                    const additional =
                      selectedBooking._original?.additionalCustomers ||
                      selectedBooking.additionalCustomers ||
                      [];
                    if (Array.isArray(additional) && additional.length > 0) {
                      return (
                        <Box sx={{ mt: 3 }}>
                          <Typography
                            variant='h6'
                            fontWeight='bold'
                            color='primary'
                            gutterBottom
                          >
                            Additional Applicants
                          </Typography>
                          <Paper sx={{ borderRadius: 2, mb: 2 }}>
                            <TableContainer>
                              <Table size='small'>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>
                                      <Typography variant='subtitle2'>
                                        Name
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant='subtitle2'>
                                        Mobile
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant='subtitle2'>
                                        Alternate
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant='subtitle2'>
                                        Relation
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant='subtitle2'>
                                        Email
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {additional.map((c, i) => (
                                    <TableRow key={`additional-${i}`}>
                                      <TableCell>{c.name || '-'}</TableCell>
                                      <TableCell>{c.mobile || '-'}</TableCell>
                                      <TableCell>
                                        {c.alternateMobile || '-'}
                                      </TableCell>
                                      <TableCell>{c.relation || '-'}</TableCell>
                                      <TableCell>{c.email || '-'}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </Box>
                      );
                    }
                    return null;
                  })()}

                  {/* Refund Status Section - Show only for cancelled bookings */}
                  {selectedBooking.status === 'cancelled' &&
                    selectedBooking.cancelDate && (
                      <Box sx={{ mt: 3 }}>
                        <Paper
                          sx={{
                            p: 3,
                            borderRadius: 2,
                            bgcolor: '#ffebee',
                            border: '2px solid #f44336',
                            boxShadow: 2,
                          }}
                        >
                          <Typography
                            variant='h6'
                            fontWeight='bold'
                            color='error'
                            gutterBottom
                            sx={{
                              mb: 2,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <Cancel fontSize='small' />
                            Refund Status
                          </Typography>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={3}>
                              <Box>
                                <Typography
                                  variant='caption'
                                  color='text.secondary'
                                  sx={{ display: 'block', mb: 0.5 }}
                                >
                                  Cancel Date
                                </Typography>
                                <Typography
                                  variant='body1'
                                  fontWeight='600'
                                  color='error.main'
                                >
                                  {selectedBooking.cancelDate || '-'}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <Box>
                                <Typography
                                  variant='caption'
                                  color='text.secondary'
                                  sx={{ display: 'block', mb: 0.5 }}
                                >
                                  Cancellation Charge
                                </Typography>
                                <Typography
                                  variant='body1'
                                  fontWeight='600'
                                  color='error.main'
                                >
                                  ₹
                                  {(
                                    selectedBooking.cancellationCharge || 0
                                  ).toLocaleString('en-IN')}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <Box>
                                <Typography
                                  variant='caption'
                                  color='text.secondary'
                                  sx={{ display: 'block', mb: 0.5 }}
                                >
                                  Refund Amount
                                </Typography>
                                <Typography
                                  variant='body1'
                                  fontWeight='600'
                                  color='success.main'
                                  sx={{ fontSize: '1.1rem' }}
                                >
                                  ₹
                                  {(
                                    selectedBooking.refundAmount || 0
                                  ).toLocaleString('en-IN')}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <Box>
                                <Typography
                                  variant='caption'
                                  color='text.secondary'
                                  sx={{ display: 'block', mb: 0.5 }}
                                >
                                  Refund Status
                                </Typography>
                                <Chip
                                  label={
                                    selectedBooking.refundStatus || 'Pending'
                                  }
                                  color={
                                    selectedBooking.refundStatus === 'Processed'
                                      ? 'success'
                                      : selectedBooking.refundStatus ===
                                        'Pending'
                                        ? 'warning'
                                        : selectedBooking.refundStatus ===
                                          'Rejected'
                                          ? 'error'
                                          : 'default'
                                  }
                                  sx={{ fontWeight: 700 }}
                                />
                              </Box>
                            </Grid>
                            {selectedBooking.refundStatus === 'Processed' && (
                              <>
                                <Grid item xs={12} sm={6} md={3}>
                                  <Box>
                                    <Typography
                                      variant='caption'
                                      color='text.secondary'
                                      sx={{ display: 'block', mb: 0.5 }}
                                    >
                                      Refund Date
                                    </Typography>
                                    <Typography
                                      variant='body1'
                                      fontWeight='600'
                                      color='success.main'
                                    >
                                      {selectedBooking.refundDate || '-'}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                  <Box>
                                    <Typography
                                      variant='caption'
                                      color='text.secondary'
                                      sx={{ display: 'block', mb: 0.5 }}
                                    >
                                      Refund Method
                                    </Typography>
                                    <Typography
                                      variant='body1'
                                      fontWeight='600'
                                    >
                                      {selectedBooking.refundMethod || '-'}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Paper>
                      </Box>
                    )}

                  {/* Financial Summary */}
                  <Box sx={{ mt: 3 }}>
                    <Paper
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        bgcolor: 'white',
                        border: '1px solid #e0e0e0',
                      }}
                    >
                      <Typography
                        variant='h6'
                        fontWeight='bold'
                        color='primary'
                        gutterBottom
                      >
                        Financial Summary
                      </Typography>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2.4}
                          sx={{
                            flexBasis: { md: '20%' },
                            maxWidth: { md: '20%' },
                          }}
                        >
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant='h5'
                              fontWeight='bold'
                              color='text.primary'
                            >
                              ₹
                              {(selectedBooking.plotAmount || 0).toLocaleString(
                                'en-IN',
                              )}
                            </Typography>
                            <Typography variant='body2' color='text.secondary'>
                              Property Amount
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2.4}
                          sx={{
                            flexBasis: { md: '20%' },
                            maxWidth: { md: '20%' },
                          }}
                        >
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant='h5'
                              fontWeight='bold'
                              color='warning.main'
                            >
                              ₹
                              {(
                                selectedBooking.totalAuthorityCharge || 0
                              ).toLocaleString('en-IN')}
                            </Typography>
                            <Typography variant='body2' color='text.secondary'>
                              Authority Charges
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2.4}
                          sx={{
                            flexBasis: { md: '20%' },
                            maxWidth: { md: '20%' },
                          }}
                        >
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant='h5'
                              fontWeight='bold'
                              color='info.main'
                            >
                              ₹
                              {(
                                selectedBooking.discountAmount || 0
                              ).toLocaleString('en-IN')}
                            </Typography>
                            <Typography variant='body2' color='text.secondary'>
                              Discount
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2.4}
                          sx={{
                            flexBasis: { md: '20%' },
                            maxWidth: { md: '20%' },
                          }}
                        >
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant='h5'
                              fontWeight='bold'
                              color='success.main'
                            >
                              ₹
                              {(selectedBooking.paidAmount || 0).toLocaleString(
                                'en-IN',
                              )}
                            </Typography>
                            <Typography variant='body2' color='text.secondary'>
                              Paid Amount
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={2.4}
                          sx={{
                            flexBasis: { md: '20%' },
                            maxWidth: { md: '20%' },
                          }}
                        >
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography
                              variant='h5'
                              fontWeight='bold'
                              color='error.main'
                            >
                              ₹
                              {Math.max(
                                0,
                                (selectedBooking.plotAmount || 0) +
                                (selectedBooking.totalAuthorityCharge || 0) -
                                (selectedBooking.discountAmount || 0) -
                                (selectedBooking.paidAmount || 0),
                              ).toLocaleString('en-IN')}
                            </Typography>
                            <Typography variant='body2' color='text.secondary'>
                              Remaining Due
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>

                    {/* Payment Progress */}
                    <Paper
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        bgcolor: 'white',
                        border: '1px solid #e0e0e0',
                        mt: 2,
                      }}
                    >
                      <Typography
                        variant='h6'
                        fontWeight='bold'
                        color='primary'
                        gutterBottom
                      >
                        Payment Progress
                      </Typography>
                      <Box sx={{ mt: 2 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            mb: 1,
                          }}
                        >
                          <Typography variant='body2' fontWeight='600'>
                            {getPaymentProgress(
                              selectedBooking.paidAmount,
                              selectedBooking.plotAmount,
                            ).toFixed(1)}
                            % Completed
                          </Typography>
                          <Typography variant='body2' fontWeight='600'>
                            ₹{selectedBooking.paidAmount.toLocaleString('en-IN')} / ₹
                            {selectedBooking.plotAmount.toLocaleString('en-IN')}
                          </Typography>
                        </Box>
                        <LinearProgress
                          variant='determinate'
                          value={getPaymentProgress(
                            selectedBooking.paidAmount,
                            selectedBooking.plotAmount,
                          )}
                          color='primary'
                          sx={{ height: 12, borderRadius: 6 }}
                        />
                      </Box>
                    </Paper>
                  </Box>
                </Box>
              )}

              {/* Tab 1: Installment (Read-Only) */}
              {activeTabLabel === 'Installment' && (
                <Box>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='primary'
                    gutterBottom
                  >
                    Installment Plan
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  {renderInstallmentContent()}
                </Box>
              )}

              {/* Tab 2: Receipt (Read-Only) */}
              {activeTabLabel === 'Receipt' && (
                <Box>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='primary'
                    gutterBottom
                  >
                    Receipt Management
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      {receiptsLoading ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            py: 4,
                          }}
                        >
                          <CircularProgress />
                          <Typography
                            variant='body2'
                            color='text.secondary'
                            sx={{ ml: 2 }}
                          >
                            Loading receipts...
                          </Typography>
                        </Box>
                      ) : receiptsError ? (
                        <Alert severity='error' sx={{ mb: 2 }}>
                          {receiptsError}
                        </Alert>
                      ) : (
                        <TableContainer component={Paper} variant='outlined'>
                          <Table size='small'>
                            <TableHead>
                              <TableRow sx={{ bgcolor: '#fafafa' }}>
                                <TableCell>
                                  <strong>Sr No.</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Receipt Date</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Receipt No.</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Receipt Type</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Payment Type</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Mode</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Ref No.</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Bank Name</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Amount</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Other Remark</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Actions</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {receipts.length === 0 ? (
                                <TableRow>
                                  <TableCell
                                    colSpan={11}
                                    align='center'
                                    sx={{ py: 4 }}
                                  >
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      No receipts found
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                receipts.map((receipt, index) => {
                                  const receiptDate = receipt.receivedDate
                                    ? new Date(receipt.receivedDate)
                                      .toISOString()
                                      .split('T')[0]
                                    : '-';
                                  const receiptType =
                                    receipt.receivedType === 'bookingAmount'
                                      ? 'Payment'
                                      : receipt.receivedType === 'refund'
                                        ? 'Refund'
                                        : 'Payment';

                                  const isRefund =
                                    receipt.receivedType === 'refund';

                                  return (
                                    <TableRow
                                      key={receipt._id}
                                      sx={{
                                        bgcolor: isRefund
                                          ? '#fff3e0'
                                          : 'inherit',
                                      }}
                                    >
                                      <TableCell>{index + 1}</TableCell>
                                      <TableCell>
                                        <Typography
                                          variant='body2'
                                          fontWeight='600'
                                        >
                                          {moment(receiptDate).format(
                                            'Do MMMM YYYY',
                                          )}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        {receipt.receiptId || '-'}
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label={receiptType}
                                          size='small'
                                          color={isRefund ? 'error' : 'primary'}
                                          variant='outlined'
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label={
                                            receipt.paymentType ===
                                              'fullPayment'
                                              ? 'FULL'
                                              : receipt.paymentType ===
                                                'partialPayment'
                                                ? 'PARTIAL'
                                                : receipt.paymentType?.toUpperCase() ||
                                                'PENDING'
                                          }
                                          size='small'
                                          color={
                                            receipt.paymentType ===
                                              'fullPayment'
                                              ? 'success'
                                              : receipt.paymentType ===
                                                'partialPayment'
                                                ? 'warning'
                                                : 'default'
                                          }
                                        />
                                      </TableCell>
                                      <TableCell>
                                        {receipt.mode || '-'}
                                      </TableCell>
                                      <TableCell>
                                        {receipt.refNo || '-'}
                                      </TableCell>
                                      <TableCell>
                                        {receipt.bankName || '-'}
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: 600 }}>
                                        ₹
                                        {(receipt.amount || 0).toLocaleString('en-IN')}
                                      </TableCell>
                                      <TableCell>
                                        {receipt.otherRemark || '-'}
                                      </TableCell>
                                      <TableCell>
                                        {receipt.receiptStatus
                                          ?.toLowerCase()
                                          .trim() !== 'pending' &&
                                          receipt.status
                                            ?.toLowerCase()
                                            .trim() !== 'pending' && (
                                            <Tooltip title='Download Receipt'>
                                              <IconButton
                                                size='small'
                                                color='info'
                                                onClick={() => {
                                                  setSelectedReceipt(receipt); // Current receipt data
                                                  setPdfType('receipt'); // Set mode to receiptre
                                                  setAutoPrintReceipt(false); // Manual download path
                                                  setPdfDialogOpen(true); // Open the modal
                                                }}
                                              >
                                                <Download fontSize='small' />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                        <Tooltip title='Print Receipt'>
                                          <IconButton
                                            size='small'
                                            color='primary'
                                            onClick={() => {
                                              setSelectedReceipt(receipt);
                                              setPdfType('receipt');
                                              setAutoPrintReceipt(true); // Trigger auto-print
                                              setPdfDialogOpen(true);
                                            }}
                                          >
                                            <Print fontSize='small' />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Tab 3: Refund Receipt (Only for Cancelled Bookings) */}
              {activeTabLabel === 'Refund Receipt' &&
                selectedBooking?.status === 'cancelled' && (
                  <Box>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      color='primary'
                      gutterBottom
                    >
                      Refund Receipt Management
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    {/* Refund Summary */}
                    {(() => {
                      const refundSummary = getRefundSummary();
                      const hasRefundData =
                        refundSummary.count > 0 ||
                        refundSummary.total > 0 ||
                        receiptsLoading;
                      return (
                        hasRefundData && (
                          <>
                            <Grid container spacing={3} sx={{ mb: 3 }}>
                              <Grid item xs={12} md={3}>
                                <Card
                                  sx={{
                                    p: 2,
                                    bgcolor: '#fff3e0',
                                    border: '1px solid #ffcc80',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      mb: 1,
                                    }}
                                  >
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                      fontWeight='600'
                                    >
                                      Total Refund
                                    </Typography>
                                    <MoneyOff color='error' />
                                  </Box>
                                  <Typography
                                    variant='h5'
                                    fontWeight='bold'
                                    color='error.main'
                                  >
                                    ₹{refundSummary.total.toLocaleString('en-IN')}
                                  </Typography>
                                  <Typography
                                    variant='caption'
                                    color='text.secondary'
                                  >
                                    {refundSummary.fromBookingInfo
                                      ? 'From booking cancellation'
                                      : `${refundSummary.count} refund receipt(s)`}
                                  </Typography>
                                </Card>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <Card
                                  sx={{
                                    p: 2,
                                    bgcolor: '#e8f5e9',
                                    border: '1px solid #81c784',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      mb: 1,
                                    }}
                                  >
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                      fontWeight='600'
                                    >
                                      Processed
                                    </Typography>
                                    <CheckCircle color='success' />
                                  </Box>
                                  <Typography
                                    variant='h5'
                                    fontWeight='bold'
                                    color='success.main'
                                  >
                                    ₹{refundSummary.processed.toLocaleString('en-IN')}
                                  </Typography>
                                  <Typography
                                    variant='caption'
                                    color='text.secondary'
                                  >
                                    Actually Refunded
                                  </Typography>
                                </Card>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <Card
                                  sx={{
                                    p: 2,
                                    bgcolor: '#fff9c4',
                                    border: '1px solid #ffd54f',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      mb: 1,
                                    }}
                                  >
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                      fontWeight='600'
                                    >
                                      Pending Refund
                                    </Typography>
                                    <Pending color='warning' />
                                  </Box>
                                  <Typography
                                    variant='h5'
                                    fontWeight='bold'
                                    color='warning.main'
                                  >
                                    ₹{refundSummary.pending.toLocaleString('en-IN')}
                                  </Typography>
                                  <Typography
                                    variant='caption'
                                    color='text.secondary'
                                  >
                                    To be Refunded
                                  </Typography>
                                </Card>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <Card
                                  sx={{
                                    p: 2,
                                    bgcolor: '#f5f5f5',
                                    border: '1px solid #bdbdbd',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      mb: 1,
                                    }}
                                  >
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                      fontWeight='600'
                                    >
                                      Total Paid
                                    </Typography>
                                    <AttachMoney color='action' />
                                  </Box>
                                  <Typography
                                    variant='h5'
                                    fontWeight='bold'
                                    color='text.primary'
                                  >
                                    ₹
                                    {(
                                      refundBookingInfo?.totalReceived ||
                                      selectedBooking?.paidAmount ||
                                      0
                                    ).toLocaleString('en-IN')}
                                  </Typography>
                                  <Typography
                                    variant='caption'
                                    color='text.secondary'
                                  >
                                    Customer Paid
                                  </Typography>
                                </Card>
                              </Grid>
                            </Grid>

                            {/* Cancellation Details */}
                            {refundSummary.cancellationDetails && (
                              <Card
                                sx={{
                                  mb: 3,
                                  p: 2,
                                  bgcolor: '#fafafa',
                                  border: '1px solid #e0e0e0',
                                }}
                              >
                                <Typography
                                  variant='h6'
                                  fontWeight='bold'
                                  color='primary'
                                  gutterBottom
                                >
                                  Cancellation Details
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6} md={3}>
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      Cancellation Charge
                                    </Typography>
                                    <Typography
                                      variant='body1'
                                      fontWeight='600'
                                    >
                                      ₹
                                      {refundSummary.cancellationDetails.chargeAmount.toLocaleString('en-IN')}
                                      {refundSummary.cancellationDetails
                                        .chargePercent > 0 && (
                                          <span
                                            style={{
                                              fontSize: '0.8em',
                                              color: '#666',
                                            }}
                                          >
                                            {' '}
                                            (
                                            {
                                              refundSummary.cancellationDetails
                                                .chargePercent
                                            }
                                            %)
                                          </span>
                                        )}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={3}>
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      Refund Method
                                    </Typography>
                                    <Typography
                                      variant='body1'
                                      fontWeight='600'
                                    >
                                      {refundSummary.cancellationDetails
                                        .method || 'N/A'}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={3}>
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      Cancelled By
                                    </Typography>
                                    <Typography
                                      variant='body1'
                                      fontWeight='600'
                                    >
                                      {refundSummary.cancellationDetails
                                        .cancelledBy || 'N/A'}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={6} md={3}>
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      Cancelled Date
                                    </Typography>
                                    <Typography
                                      variant='body1'
                                      fontWeight='600'
                                    >
                                      {refundSummary.cancellationDetails
                                        .cancelledAt
                                        ? new Date(
                                          refundSummary.cancellationDetails
                                            .cancelledAt,
                                        ).toLocaleDateString()
                                        : 'N/A'}
                                    </Typography>
                                  </Grid>
                                  {refundSummary.cancellationDetails.reason && (
                                    <Grid item xs={12}>
                                      <Typography
                                        variant='body2'
                                        color='text.secondary'
                                      >
                                        Cancellation Reason
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        fontWeight='600'
                                      >
                                        {
                                          refundSummary.cancellationDetails
                                            .reason
                                        }
                                      </Typography>
                                    </Grid>
                                  )}
                                </Grid>
                              </Card>
                            )}
                          </>
                        )
                      );
                    })()}

                    {/* Create Refund Receipt Button */}
                    {canWriteBooking && canCancelBooking && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          mb: 3,
                        }}
                      >
                        <Button
                          variant='contained'
                          color='primary'
                          startIcon={<Receipt />}
                          onClick={handleOpenRefundDialog}
                          sx={{ textTransform: 'none' }}
                        >
                          Create Refund Receipt
                        </Button>
                      </Box>
                    )}

                    {/* Old Create Refund Receipt Form - Hidden */}
                    <Card
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: '#f9f9fb',
                        border: '1px solid #e0e0e0',
                        display: 'none',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Receipt sx={{ fontSize: 20, color: 'primary.main' }} />
                        <Typography variant='subtitle2' fontWeight='600'>
                          Create New Refund Receipt (Old Form)
                        </Typography>
                      </Box>
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            fullWidth
                            size='small'
                            label='Receipt No'
                            value={newRefundReceipt.receiptNo}
                            onChange={(e) => {
                              setNewRefundReceipt({
                                ...newRefundReceipt,
                                receiptNo: e.target.value,
                              });
                            }}
                            placeholder='Auto-generated'
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            fullWidth
                            size='small'
                            label='Refund Date'
                            type='date'
                            value={newRefundReceipt.refundDate}
                            onChange={(e) => {
                              setNewRefundReceipt({
                                ...newRefundReceipt,
                                refundDate: e.target.value,
                              });
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            fullWidth
                            size='small'
                            label='Amount'
                            type='number'
                            value={newRefundReceipt.amount}
                            onChange={(e) => {
                              setNewRefundReceipt({
                                ...newRefundReceipt,
                                amount: e.target.value,
                              });
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  position='start'
                                  sx={{ fontSize: '0.875rem' }}
                                >
                                  ₹
                                </InputAdornment>
                              ),
                            }}
                            inputProps={{ min: 0, step: 0.01 }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <Autocomplete
                            fullWidth
                            size='small'
                            options={[
                              'Bank Transfer',
                              'Cash',
                              'Cheque',
                              'Credit Card',
                              'Debit Card',
                              'UPI',
                              'Online Transfer',
                              'DD (Demand Draft)',
                              'NEFT',
                              'RTGS',
                            ]}
                            value={newRefundReceipt.method || null}
                            onChange={(event, newValue) => {
                              setNewRefundReceipt({
                                ...newRefundReceipt,
                                method: newValue || '',
                              });
                            }}
                            freeSolo
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label='Payment Mode'
                                placeholder='Select or enter'
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth size='small'>
                            <InputLabel>Status</InputLabel>
                            <Select
                              value={newRefundReceipt.status}
                              onChange={(e) => {
                                setNewRefundReceipt({
                                  ...newRefundReceipt,
                                  status: e.target.value,
                                });
                              }}
                              label='Status'
                            >
                              <MenuItem value='Pending'>Pending</MenuItem>
                              <MenuItem value='Processed'>Processed</MenuItem>
                              <MenuItem value='Rejected'>Rejected</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            fullWidth
                            size='small'
                            label='Remarks'
                            value={newRefundReceipt.remarks}
                            onChange={(e) => {
                              setNewRefundReceipt({
                                ...newRefundReceipt,
                                remarks: e.target.value,
                              });
                            }}
                            placeholder='Optional'
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Button
                              size='small'
                              variant='outlined'
                              onClick={() => {
                                setNewRefundReceipt({
                                  receiptNo: '',
                                  refundDate: '',
                                  amount: '',
                                  method: '',
                                  status: 'Pending',
                                  remarks: '',
                                });
                              }}
                            >
                              Clear
                            </Button>
                            <Button
                              size='small'
                              variant='contained'
                              color='primary'
                              onClick={() => {
                                if (!selectedBooking) return;

                                const generateReceiptNo = () => {
                                  const existingRefunds =
                                    selectedBooking.refunds || [];
                                  const nextNumber = existingRefunds.length + 1;
                                  return `RF-${selectedBooking.bookingId}-${String(nextNumber).padStart(3, '0')}`;
                                };

                                const receiptNo =
                                  newRefundReceipt.receiptNo ||
                                  generateReceiptNo();

                                const newRefund = {
                                  receiptNo: receiptNo,
                                  refundDate: newRefundReceipt.refundDate || '',
                                  amount:
                                    parseFloat(newRefundReceipt.amount) || 0,
                                  method: newRefundReceipt.method || '',
                                  status: newRefundReceipt.status || 'Pending',
                                  remarks: newRefundReceipt.remarks || '',
                                };

                                const updatedRefunds = [
                                  ...(selectedBooking.refunds || []),
                                  newRefund,
                                ];

                                setSelectedBooking({
                                  ...selectedBooking,
                                  refunds: updatedRefunds,
                                });

                                // Reset form
                                setNewRefundReceipt({
                                  receiptNo: '',
                                  refundDate: '',
                                  amount: '',
                                  method: '',
                                  status: 'Pending',
                                  remarks: '',
                                });
                              }}
                              disabled={
                                !newRefundReceipt.amount ||
                                parseFloat(newRefundReceipt.amount) <= 0
                              }
                              startIcon={<Receipt />}
                            >
                              Add Receipt
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>

                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TableContainer component={Paper} variant='outlined'>
                          <Table size='small'>
                            <TableHead>
                              <TableRow sx={{ bgcolor: '#fafafa' }}>
                                <TableCell>
                                  <strong>Receipt No</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Date</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Amount</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Payment Mode</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Status</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Actions</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(() => {
                                const refundTransactions =
                                  getRefundTransactions();
                                const refundSummary = getRefundSummary();

                                // If there are transactions, show them
                                if (refundTransactions.length > 0) {
                                  return refundTransactions.map(
                                    (refund, refundIndex) => (
                                      <TableRow
                                        key={`transaction-${refundIndex}`}
                                        sx={{ bgcolor: '#fff3e0' }}
                                      >
                                        <TableCell>
                                          <Typography
                                            variant='body2'
                                            fontWeight='600'
                                          >
                                            {refund.receiptId ||
                                              refund.refNo ||
                                              `TXN-${refund._id?.slice(-6)?.toUpperCase()}`}
                                          </Typography>
                                        </TableCell>
                                        <TableCell>
                                          {refund.receivedDate
                                            ? new Date(
                                              refund.receivedDate,
                                            ).toLocaleDateString()
                                            : '-'}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            color: 'error.main',
                                            fontWeight: 600,
                                          }}
                                        >
                                          ₹
                                          {(
                                            refund.amount || 0
                                          ).toLocaleString('en-IN')}
                                        </TableCell>
                                        <TableCell>
                                          {refund.mode || '-'}
                                        </TableCell>
                                        <TableCell>
                                          <Chip
                                            label={
                                              refund.status ||
                                              (refund.transactionType ===
                                                'deduct'
                                                ? 'Processed'
                                                : 'Pending')
                                            }
                                            size='small'
                                            color={
                                              refund.status === 'Processed' ||
                                                refund.transactionType ===
                                                'deduct'
                                                ? 'success'
                                                : refund.status === 'Pending'
                                                  ? 'warning'
                                                  : refund.status === 'Rejected'
                                                    ? 'error'
                                                    : 'default'
                                            }
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <Tooltip title='Print Refund Receipt'>
                                            <IconButton
                                              size='small'
                                              color='primary'
                                              onClick={() => {
                                                const printWindow = window.open(
                                                  '',
                                                  '_blank',
                                                );
                                                if (printWindow) {
                                                  printWindow.document.write(`
                                              <html>
                                                <head>
                                                  <title>Refund Receipt - ${refund.receiptNo}</title>
                                                  <style>
                                                    body { font-family: Arial, sans-serif; padding: 20px; }
                                                    .header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 30px; }
                                                    .receipt-info { display: flex; justify-content: space-between; margin-bottom: 20px; }
                                                    .section { margin-bottom: 25px; }
                                                    .amount-box { background: #f5f5f5; padding: 15px; border-radius: 5px; margin: 10px 0; }
                                                    .footer { margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px; }
                                                    table { width: 100%; border-collapse: collapse; margin: 20px 0; }
                                                    th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
                                                    th { background: #f5f5f5; font-weight: bold; }
                                                  </style>
                                                </head>
                                                <body>
                                                  <div class="header">
                                                    <h1>REFUND RECEIPT</h1>
                                                    <p>Receipt No: ${refund.receiptNo}</p>
                                                  </div>
                                                  <div class="receipt-info">
                                                    <div>
                                                      <p><strong>Booking ID:</strong> ${selectedBooking.bookingId}</p>
                                                      <p><strong>Customer Name:</strong> ${selectedBooking.customer}</p>
                                                      <p><strong>Property Number:</strong> ${selectedBooking.plotNo}</p>
                                                    </div>
                                                    <div>
                                                      <p><strong>Refund Date:</strong> ${refund.refundDate || selectedBooking.cancelDate || '-'}</p>
                                                      <p><strong>Cancel Date:</strong> ${selectedBooking.cancelDate}</p>
                                                      <p><strong>Branch:</strong> ${selectedBooking.branchName}</p>
                                                    </div>
                                                  </div>
                                                  <div class="section">
                                                    <h3>Refund Details</h3>
                                                    <table>
                                                      <tr>
                                                        <th>Description</th>
                                                        <th>Amount (₹)</th>
                                                      </tr>
                                                      <tr>
                                                        <td>Refund Amount</td>
                                                        <td>₹${(refund.amount || 0).toLocaleString('en-IN')}</td>
                                                      </tr>
                                                      ${refund.remarks ? `<tr><td colspan="2"><strong>Remarks:</strong> ${refund.remarks}</td></tr>` : ''}
                                                    </table>
                                                  </div>
                                                  <div class="section">
                                                    <div class="amount-box">
                                                      <h2 style="text-align: center; color: #2e7d32;">
                                                        Refund Amount: ₹${(refund.amount || 0).toLocaleString('en-IN')}
                                                      </h2>
                                                      <p style="text-align: center; margin: 5px 0;">
                                                        Status: <strong>${refund.status || 'Pending'}</strong>
                                                      </p>
                                                      ${refund.method ? `<p style="text-align: center; margin: 5px 0;">Refund Method: <strong>${refund.method}</strong></p>` : ''}
                                                    </div>
                                                  </div>
                                                  <div class="footer">
                                                    <p>This is a system generated refund receipt.</p>
                                                    <p>For any queries, please contact support.</p>
                                                  </div>
                                                </body>
                                              </html>
                                            `);
                                                  printWindow.document.close();
                                                  setTimeout(
                                                    () => printWindow.print(),
                                                    250,
                                                  );
                                                }
                                              }}
                                            >
                                              <Print fontSize='small' />
                                            </IconButton>
                                          </Tooltip>
                                          {refund.status?.toLowerCase() !==
                                            'pending' && (
                                              <Tooltip title='Download Refund Receipt PDF'>
                                                <IconButton
                                                  size='small'
                                                  color='info'
                                                  onClick={() => {
                                                    const printWindow =
                                                      window.open('', '_blank');
                                                    if (printWindow) {
                                                      printWindow.document.write(`
                                                <html>
                                                  <head>
                                                    <title>Refund Receipt - ${refund.receiptNo}</title>
                                                    <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; }
                                                      .header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 30px; }
                                                      .receipt-info { display: flex; justify-content: space-between; margin-bottom: 20px; }
                                                      .section { margin-bottom: 25px; }
                                                      .amount-box { background: #f5f5f5; padding: 15px; border-radius: 5px; margin: 10px 0; }
                                                      .footer { margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px; }
                                                      table { width: 100%; border-collapse: collapse; margin: 20px 0; }
                                                      th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
                                                      th { background: #f5f5f5; font-weight: bold; }
                                                    </style>
                                                  </head>
                                                  <body>
                                                    <div class="header">
                                                      <h1>REFUND RECEIPT</h1>
                                                      <p>Receipt No: ${refund.receiptNo}</p>
                                                    </div>
                                                    <div class="receipt-info">
                                                      <div>
                                                        <p><strong>Booking ID:</strong> ${selectedBooking.bookingId}</p>
                                                        <p><strong>Customer Name:</strong> ${selectedBooking.customer}</p>
                                                        <p><strong>Property Number:</strong> ${selectedBooking.plotNo}</p>
                                                      </div>
                                                      <div>
                                                        <p><strong>Refund Date:</strong> ${refund.refundDate || selectedBooking.cancelDate || '-'}</p>
                                                        <p><strong>Cancel Date:</strong> ${selectedBooking.cancelDate}</p>
                                                        <p><strong>Branch:</strong> ${selectedBooking.branchName}</p>
                                                      </div>
                                                    </div>
                                                    <div class="section">
                                                      <h3>Refund Details</h3>
                                                      <table>
                                                        <tr>
                                                          <th>Description</th>
                                                          <th>Amount (₹)</th>
                                                        </tr>
                                                        <tr>
                                                          <td>Refund Amount</td>
                                                          <td>₹${(refund.amount || 0).toLocaleString('en-IN')}</td>
                                                        </tr>
                                                        ${refund.remarks ? `<tr><td colspan="2"><strong>Remarks:</strong> ${refund.remarks}</td></tr>` : ''}
                                                      </table>
                                                    </div>
                                                    <div class="section">
                                                      <div class="amount-box">
                                                        <h2 style="text-align: center; color: #2e7d32;">
                                                          Refund Amount: ₹${(refund.amount || 0).toLocaleString('en-IN')}
                                                        </h2>
                                                        <p style="text-align: center; margin: 5px 0;">
                                                          Status: <strong>${refund.status || 'Pending'}</strong>
                                                        </p>
                                                        ${refund.method ? `<p style="text-align: center; margin: 5px 0;">Refund Method: <strong>${refund.method}</strong></p>` : ''}
                                                      </div>
                                                    </div>
                                                    <div class="footer">
                                                      <p>This is a system generated refund receipt.</p>
                                                      <p>For any queries, please contact support.</p>
                                                    </div>
                                                  </body>
                                                </html>
                                              `);
                                                      printWindow.document.close();
                                                      setTimeout(
                                                        () => printWindow.print(),
                                                        250,
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <Download fontSize='small' />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                        </TableCell>
                                      </TableRow>
                                    ),
                                  );
                                }

                                // If no transactions but refund from booking info, show booking refund
                                if (
                                  refundTransactions.length === 0 &&
                                  refundSummary.fromBookingInfo &&
                                  refundSummary.total > 0
                                ) {
                                  return (
                                    <TableRow
                                      key='booking-refund'
                                      sx={{ bgcolor: '#fff3e0' }}
                                    >
                                      <TableCell>
                                        <Typography
                                          variant='body2'
                                          fontWeight='600'
                                        >
                                          BOOKING-REFUND-
                                          {selectedBooking?.bookingId || 'N/A'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        {refundSummary.cancellationDetails
                                          ?.cancelledAt
                                          ? new Date(
                                            refundSummary.cancellationDetails
                                              .cancelledAt,
                                          ).toLocaleDateString()
                                          : '-'}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          color: 'error.main',
                                          fontWeight: 600,
                                        }}
                                      >
                                        ₹{refundSummary.total.toLocaleString('en-IN')}
                                      </TableCell>
                                      <TableCell>
                                        {refundSummary.cancellationDetails
                                          ?.method || '-'}
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label='Processed'
                                          size='small'
                                          color='success'
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Tooltip title='Print Refund Receipt'>
                                          <IconButton
                                            size='small'
                                            color='primary'
                                            onClick={() => {
                                              const printWindow = window.open(
                                                '',
                                                '_blank',
                                              );
                                              if (printWindow) {
                                                printWindow.document.write(`
                                                <html>
                                                  <head>
                                                    <title>Refund Receipt - BOOKING-REFUND-${selectedBooking?.bookingId}</title>
                                                    <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; }
                                                      .header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 30px; }
                                                      .receipt-info { display: flex; justify-content: space-between; margin-bottom: 20px; }
                                                      .section { margin-bottom: 25px; }
                                                      .amount-box { background: #f5f5f5; padding: 15px; border-radius: 5px; margin: 10px 0; }
                                                      .footer { margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px; }
                                                      table { width: 100%; border-collapse: collapse; margin: 20px 0; }
                                                      th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
                                                      th { background: #f5f5f5; font-weight: bold; }
                                                    </style>
                                                  </head>
                                                  <body>
                                                    <div class="header">
                                                      <h1>REFUND RECEIPT</h1>
                                                      <p>Receipt No: BOOKING-REFUND-${selectedBooking?.bookingId}</p>
                                                    </div>
                                                    <div class="receipt-info">
                                                      <div>
                                                        <p><strong>Booking ID:</strong> ${selectedBooking?.bookingId}</p>
                                                        <p><strong>Customer Name:</strong> ${refundBookingInfo?.customer?.name || selectedBooking?.customer}</p>
                                                        <p><strong>Property Number:</strong> ${refundBookingInfo?.particular?.inventoryDetail || selectedBooking?.plotNo}</p>
                                                      </div>
                                                      <div>
                                                        <p><strong>Refund Date:</strong> ${refundSummary.cancellationDetails?.cancelledAt ? new Date(refundSummary.cancellationDetails.cancelledAt).toLocaleDateString() : '-'}</p>
                                                        <p><strong>Cancel Date:</strong> ${refundSummary.cancellationDetails?.cancelledAt ? new Date(refundSummary.cancellationDetails.cancelledAt).toLocaleDateString() : '-'}</p>
                                                        <p><strong>Refund Method:</strong> ${refundSummary.cancellationDetails?.method || '-'}</p>
                                                      </div>
                                                    </div>
                                                    <div class="section">
                                                      <h3>Refund Details</h3>
                                                      <table>
                                                        <tr>
                                                          <th>Description</th>
                                                          <th>Amount (₹)</th>
                                                        </tr>
                                                        <tr>
                                                          <td>Total Paid Amount</td>
                                                          <td>₹${(refundBookingInfo?.totalReceived || 0).toLocaleString('en-IN')}</td>
                                                        </tr>
                                                        <tr>
                                                          <td>Cancellation Charge (${refundSummary.cancellationDetails?.chargePercent || 0}%)</td>
                                                          <td>₹${(refundSummary.cancellationDetails?.chargeAmount || 0).toLocaleString('en-IN')}</td>
                                                        </tr>
                                                        <tr style="border-top: 2px solid #333; font-weight: bold;">
                                                          <td>Refund Amount</td>
                                                          <td>₹${refundSummary.total.toLocaleString('en-IN')}</td>
                                                        </tr>
                                                        ${refundSummary.cancellationDetails?.reason ? `<tr><td colspan="2"><strong>Cancellation Reason:</strong> ${refundSummary.cancellationDetails.reason}</td></tr>` : ''}
                                                      </table>
                                                    </div>
                                                    <div class="section">
                                                      <div class="amount-box">
                                                        <h2 style="text-align: center; color: #2e7d32;">
                                                          Total Refund: ₹${refundSummary.total.toLocaleString('en-IN')}
                                                        </h2>
                                                      </div>
                                                    </div>
                                                    <div class="footer">
                                                      <p>This is a computer generated receipt and does not require signature.</p>
                                                      <p>Cancelled By: ${refundSummary.cancellationDetails?.cancelledBy || 'N/A'}</p>
                                                      <p>Generated on: ${new Date().toLocaleString('en-IN')}</p>
                                                    </div>
                                                  </body>
                                                </html>
                                              `);
                                                printWindow.document.close();
                                                setTimeout(() => {
                                                  printWindow.print();
                                                }, 250);
                                              }
                                            }}
                                          >
                                            <Print fontSize='small' />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  );
                                }

                                // No refunds available
                                return (
                                  <TableRow>
                                    <TableCell
                                      colSpan={6}
                                      align='center'
                                      sx={{ py: 4 }}
                                    >
                                      <Typography
                                        variant='body2'
                                        color='text.secondary'
                                      >
                                        {receiptsLoading
                                          ? 'Loading refund receipts...'
                                          : 'No refund receipts available'}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                );
                              })()}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Box>
                )}

              {/* Tab 3/4: Document (Read-Only) - Adjust index based on cancelled status */}
              {activeTabLabel === 'Document' && (
                <Box>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='primary'
                    gutterBottom
                  >
                    Document Management
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        gutterBottom
                      >
                        Uploaded Documents
                      </Typography>
                      {documentsLoading ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            py: 4,
                          }}
                        >
                          <CircularProgress />
                          <Typography
                            variant='body2'
                            color='text.secondary'
                            sx={{ ml: 2 }}
                          >
                            Loading documents...
                          </Typography>
                        </Box>
                      ) : documentsError ? (
                        <Alert severity='error' sx={{ mb: 2 }}>
                          {documentsError}
                        </Alert>
                      ) : documents.length === 0 ? (
                        <Paper
                          sx={{ p: 3, textAlign: 'center', bgcolor: '#f8f9fa' }}
                        >
                          <Typography variant='body2' color='text.secondary'>
                            No documents uploaded yet.
                          </Typography>
                        </Paper>
                      ) : (
                        <Grid container spacing={2}>
                          {documents.map((doc, idx) => (
                            <Grid item xs={12} md={6} key={doc._id || idx}>
                              <Paper
                                sx={{
                                  p: 2,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                }}
                              >
                                <Description color='primary' />
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant='body2' fontWeight='600'>
                                    {doc.name || doc.type || 'Document'}
                                  </Typography>
                                  <Typography
                                    variant='caption'
                                    color='text.secondary'
                                    display='block'
                                  >
                                    Type: {doc.type || 'N/A'}
                                  </Typography>
                                  <Typography
                                    variant='caption'
                                    color='text.secondary'
                                    display='block'
                                  >
                                    Uploaded:{' '}
                                    {doc.uploadedAt
                                      ? new Date(
                                        doc.uploadedAt,
                                      ).toLocaleDateString()
                                      : 'N/A'}
                                    {doc.uploadedBy && ` by ${doc.uploadedBy}`}
                                  </Typography>
                                </Box>
                                <IconButton
                                  size='small'
                                  color='primary'
                                  title='Download'
                                  onClick={() => {
                                    // Use viewUrl from API response if available, otherwise use doc.url
                                    const url = doc.viewUrl || doc.url;
                                    if (url) {
                                      window.open(url, '_blank');
                                    } else {
                                      alert('Document URL not available');
                                    }
                                  }}
                                >
                                  <Download fontSize='small' />
                                </IconButton>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Tab 4/5: Followup/Remark (Read-Only) - Adjust index based on cancelled status */}
              {activeTabLabel === 'Followup/Remark' && (
                <Box>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='primary'
                    gutterBottom
                  >
                    Followup & Remarks
                  </Typography>
                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        gutterBottom
                      >
                        Previous Remarks
                      </Typography>
                      {followUpsLoading ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            py: 4,
                          }}
                        >
                          <CircularProgress />
                          <Typography
                            variant='body2'
                            color='text.secondary'
                            sx={{ ml: 2 }}
                          >
                            Loading follow-ups...
                          </Typography>
                        </Box>
                      ) : followUpsError ? (
                        <Alert severity='error' sx={{ mb: 2 }}>
                          {followUpsError}
                        </Alert>
                      ) : followUps.length === 0 ? (
                        <Paper
                          sx={{ p: 3, textAlign: 'center', bgcolor: '#f8f9fa' }}
                        >
                          <Typography variant='body2' color='text.secondary'>
                            No follow-ups found for this booking.
                          </Typography>
                        </Paper>
                      ) : (
                        <TableContainer
                          component={Paper}
                          sx={{
                            boxShadow: 'none',
                            border: '1px solid #f0f0f0',
                            borderRadius: 2,
                          }}
                        >
                          <Table size='small'>
                            <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Followup Date
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Next Followup Date
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Status
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Remark
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                  Created By
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {followUps.map((followUp, idx) => {
                                const fDate =
                                  followUp.followUpDate ||
                                  followUp.date ||
                                  followUp.createdAt ||
                                  followUp.createdOn;
                                const formattedFollowUpDate = fDate
                                  ? new Date(fDate).toLocaleString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                  })
                                  : '-';

                                const nextFDate = followUp.nextFollowUpDate;
                                const formattedNextDate = nextFDate
                                  ? new Date(nextFDate).toLocaleString(
                                    'en-IN',
                                    {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                    },
                                  )
                                  : '-';

                                const status =
                                  followUp.status || followUp.type || '-';
                                const remark =
                                  followUp.remark ||
                                  followUp.description ||
                                  '-';
                                const createdBy =
                                  followUp.addedBy ||
                                  followUp.createdBy ||
                                  followUp.createdByUser ||
                                  'Admin';

                                return (
                                  <TableRow key={followUp._id || idx} hover>
                                    <TableCell sx={{ fontSize: '0.875rem' }}>
                                      {formattedFollowUpDate}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '0.875rem' }}>
                                      {formattedNextDate}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '0.875rem' }}>
                                      <Chip
                                        label={status}
                                        size='small'
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: '0.75rem',
                                          bgcolor:
                                            status.toUpperCase() === 'HOT'
                                              ? '#ffebee'
                                              : '#e3f2fd',
                                          color:
                                            status.toUpperCase() === 'HOT'
                                              ? '#c62828'
                                              : '#1565c0',
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontSize: '0.875rem',
                                        maxWidth: 300,
                                        wordBreak: 'break-word',
                                      }}
                                    >
                                      {remark}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '0.875rem' }}>
                                      {createdBy}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component='div'
                            count={followUpsTotalCount}
                            rowsPerPage={followUpsRowsPerPage}
                            page={followUpsPage}
                            onPageChange={(e, newPage) =>
                              setFollowUpsPage(newPage)
                            }
                            onRowsPerPageChange={(e) => {
                              setFollowUpsRowsPerPage(
                                parseInt(e.target.value, 10),
                              );
                              setFollowUpsPage(0);
                            }}
                          />
                        </TableContainer>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Tab 5/6: Commission (Read-Only) - Adjust index based on cancelled status */}
              {activeTabLabel === 'Commission' && (
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Typography variant='h6' fontWeight='bold' color='primary'>
                        Commission Details
                      </Typography>
                      {isCommissionTypeFixed && (
                        <Chip
                          label='Commission Fixed'
                          color='success'
                          size='small'
                          sx={{
                            fontWeight: 700,
                            letterSpacing: 0.5,
                            borderRadius: 1.5,
                            boxShadow: '0 2px 6px rgba(76, 175, 80, 0.25)',
                          }}
                        />
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <Typography
                        variant='subtitle1'
                        fontWeight='bold'
                        color='text.secondary'
                      >
                        Total Distribution Amount: ₹{totalDistribution.toLocaleString('en-IN')}
                      </Typography>
                      <Typography
                        variant='h6'
                        fontWeight='bold'
                        color='success.main'
                      >
                        Total Payable: ₹{totalCommission.toLocaleString('en-IN')}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 2.5 }} />

                  {/* Display Fixed Commission Remark if present */}
                  {Boolean(fixedCommissionRemark && String(fixedCommissionRemark).trim()) && (
                    <Alert
                      severity='info'
                      sx={{
                        mb: 2.5,
                        borderRadius: 2,
                        bgcolor: 'rgba(25, 118, 210, 0.06)',
                        border: '1px solid rgba(25, 118, 210, 0.2)',
                        '& .MuiAlert-icon': { fontSize: 22, color: 'primary.main' }
                      }}
                    >
                      <Typography variant='subtitle2' sx={{ fontWeight: 700, color: 'primary.main' }}>
                        Fixed Commission Remark:
                      </Typography>
                      <Typography variant='body2' sx={{ fontWeight: 500, mt: 0.3, color: 'text.primary' }}>
                        {fixedCommissionRemark}
                      </Typography>
                    </Alert>
                  )}

                  {/* Filter & View Switcher Row */}
                  <Box
                    sx={{
                      mb: 2.5,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: 2,
                    }}
                  >
                    <Autocomplete
                      sx={{ width: { xs: '100%', sm: 300 } }}
                      size='small'
                      options={associatesList}
                      getOptionLabel={(option) => {
                        const name = option.name || '';
                        const id = option.associateId || option._id || '';
                        return id ? `${name} (${id})` : name;
                      }}
                      isOptionEqualToValue={(option, value) =>
                        (option._id || option.id) === (value?._id || value?.id)
                      }
                      value={commissionsAssociateFilter}
                      onChange={(event, newValue) => {
                        setCommissionsAssociateFilter(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label='Filter by Associate'
                          placeholder='Search associate...'
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position='start'>
                                <Search
                                  sx={{ fontSize: 20, color: 'text.secondary' }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />

                    {/* View Switcher: Receipts View vs Grouped View */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant='body2' sx={{ fontWeight: 600, color: 'text.secondary' }}>
                        View Mode:
                      </Typography>
                      <ToggleButtonGroup
                        size='small'
                        value={commissionViewMode}
                        exclusive
                        onChange={(e, newMode) => {
                          if (newMode) setCommissionViewMode(newMode);
                        }}
                        sx={{
                          bgcolor: 'background.paper',
                          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                          '& .MuiToggleButton-root': {
                            px: 1.8,
                            py: 0.6,
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.8125rem',
                            '&.Mui-selected': {
                              bgcolor: 'primary.main',
                              color: '#fff',
                              '&:hover': {
                                bgcolor: 'primary.dark',
                              },
                            },
                          },
                        }}
                      >
                        <ToggleButton value='detailed'>
                          <ReceiptLong sx={{ fontSize: 17, mr: 0.8 }} />
                          Receipts View
                        </ToggleButton>
                        <ToggleButton value='grouped'>
                          <Groups sx={{ fontSize: 18, mr: 0.8 }} />
                          Grouped View
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      {commissionViewMode === 'grouped' ? (
                        <TableContainer component={Paper} variant='outlined'>
                          <Table size='small'>
                            <TableHead>
                              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell sx={{ width: 45 }} />
                                <TableCell><strong>Associate</strong></TableCell>
                                <TableCell><strong>Project / Unit</strong></TableCell>
                                <TableCell align='center'><strong>Commission %</strong></TableCell>
                                {/* <TableCell align='right'><strong>Total Received</strong></TableCell> */}
                                <TableCell align='right'><strong>Total Payable</strong></TableCell>
                                {/* <TableCell align='right'><strong>Paid</strong></TableCell> */}
                                {/* <TableCell align='right'><strong>Due</strong></TableCell> */}
                                <TableCell align='center'><strong>Receipts</strong></TableCell>
                                {/* <TableCell align='center'><strong>Status</strong></TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {commissionsLoading && (
                                <TableRow>
                                  <TableCell colSpan={10} align='center' sx={{ py: 4 }}>
                                    <CircularProgress size={24} />
                                  </TableCell>
                                </TableRow>
                              )}
                              {!commissionsLoading && commissionsError && (
                                <TableRow>
                                  <TableCell colSpan={10} align='center' sx={{ color: 'error.main', py: 3 }}>
                                    {commissionsError}
                                  </TableCell>
                                </TableRow>
                              )}
                              {!commissionsLoading && !commissionsError && commissions.length === 0 && (
                                <TableRow>
                                  <TableCell colSpan={10} align='center' sx={{ py: 3, color: 'text.secondary' }}>
                                    No grouped commission records found for this booking.
                                  </TableCell>
                                </TableRow>
                              )}
                              {!commissionsLoading && !commissionsError && commissions.map((row) => {
                                const isExpanded = Boolean(expandedGroupedRows[row._id]);
                                const receiptsList = Array.isArray(row.receipts) ? row.receipts : [];

                                return (
                                  <React.Fragment key={row._id}>
                                    <TableRow hover sx={{ '& > *': { borderBottom: 'unset' } }}>
                                      <TableCell>
                                        {receiptsList.length > 0 && (
                                          <IconButton
                                            aria-label='expand row'
                                            size='small'
                                            onClick={() => toggleRowExpansion(row._id)}
                                          >
                                            {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                          </IconButton>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant='body2' fontWeight='bold'>
                                          {row.associate || '-'}
                                        </Typography>
                                        <Typography variant='caption' display='block' color='text.secondary'>
                                          {row.associatePhone ? `${row.associatePhone} • ` : ''}
                                          {row.associateDesignation || row.associateRole || 'Associate'}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant='body2'>
                                          {row.project || '-'}
                                        </Typography>
                                        <Typography variant='caption' display='block' color='text.secondary'>
                                          {row.unitType} {row.unitDetail ? `- ${row.unitDetail}` : ''}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align='center'>
                                        <Chip
                                          size='small'
                                          label={`${row.payableCommissionPercent}%`}
                                          color='primary'
                                          variant='outlined'
                                          sx={{ fontWeight: 700 }}
                                        />
                                      </TableCell>
                                      {/* <TableCell align='right'>
                                        ₹{(row.receivedAmount || row.paymentAmount || 0).toLocaleString('en-IN')}
                                      </TableCell> */}
                                      <TableCell align='right' sx={{ color: 'success.main', fontWeight: 'bold' }}>
                                        ₹{(row.payableCommissionAmount || 0).toLocaleString('en-IN')}
                                      </TableCell>
                                      {/* <TableCell align='right' sx={{ color: 'primary.main', fontWeight: 600 }}>
                                        ₹{(row.paidAmount || 0).toLocaleString('en-IN')}
                                      </TableCell>
                                      <TableCell align='right' sx={{ color: (row.dueCommissionAmount || 0) > 0 ? 'warning.dark' : 'text.secondary', fontWeight: 600 }}>
                                        ₹{(row.dueCommissionAmount || 0).toLocaleString('en-IN')}
                                      </TableCell> */}
                                      <TableCell align='center'>
                                        <Chip
                                          size='small'
                                          label={`${row.receiptCount || receiptsList.length} Receipts`}
                                          onClick={() => toggleRowExpansion(row._id)}
                                          color='info'
                                          variant='filled'
                                          sx={{ fontWeight: 600, cursor: 'pointer', fontSize: '0.75rem' }}
                                        />
                                      </TableCell>
                                      {/* <TableCell align='center'>
                                        <Chip
                                          size='small'
                                          label={row.allApproved ? 'Approved' : row.anyApproved ? 'Partially Approved' : 'Pending'}
                                          color={row.allApproved ? 'success' : row.anyApproved ? 'warning' : 'default'}
                                          variant='filled'
                                          sx={{ fontWeight: 700, fontSize: '0.75rem' }}
                                        />
                                      </TableCell> */}
                                    </TableRow>

                                    {/* Collapsible Sub-Table for Receipts */}
                                    <TableRow>
                                      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                                        <Collapse in={isExpanded} timeout='auto' unmountOnExit>
                                          <Box sx={{ margin: 2, p: 2, bgcolor: '#fcfcfc', borderRadius: 2, border: '1px solid #e0e0e0' }}>
                                            <Typography variant='subtitle2' fontWeight='bold' color='primary' gutterBottom>
                                              Receipts Breakdown for {row.associate}
                                            </Typography>
                                            <Table size='small'>
                                              <TableHead>
                                                <TableRow sx={{ bgcolor: '#eee' }}>
                                                  <TableCell><strong>Receipt No.</strong></TableCell>
                                                  <TableCell><strong>Received Date</strong></TableCell>
                                                  <TableCell align='right'><strong>Received Amount</strong></TableCell>
                                                  <TableCell align='center'><strong>Comm. %</strong></TableCell>
                                                  <TableCell align='right'><strong>Payable Commission</strong></TableCell>
                                                  {/* <TableCell align='center'><strong>Status</strong></TableCell> */}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {receiptsList.map((rcp, rIdx) => (
                                                  <TableRow key={rcp.receiptId || rcp._id || rIdx} hover>
                                                    <TableCell>
                                                      <Typography variant='body2' fontWeight='bold' color='primary'>
                                                        {rcp.receiptNo || '-'}
                                                      </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                      {rcp.receivedDate ? new Date(rcp.receivedDate).toLocaleDateString('en-IN') : '-'}
                                                    </TableCell>
                                                    <TableCell align='right'>
                                                      ₹{(rcp.receivedAmount || rcp.paymentAmount || 0).toLocaleString('en-IN')}
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                      {rcp.payableCommissionPercent}%
                                                    </TableCell>
                                                    <TableCell align='right' sx={{ color: 'success.main', fontWeight: 'bold' }}>
                                                      ₹{(rcp.payableCommissionAmount || 0).toLocaleString('en-IN')}
                                                    </TableCell>
                                                    {/* <TableCell align='center'>
                                                      <Chip
                                                        size='small'
                                                        label={rcp.isApproved ? 'Approved' : 'Pending'}
                                                        color={rcp.isApproved ? 'success' : 'default'}
                                                        variant='outlined'
                                                        sx={{ fontWeight: 600, fontSize: '0.7rem' }}
                                                      />
                                                    </TableCell> */}
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <TableContainer component={Paper} variant='outlined'>
                          <Table size='small'>
                            <TableHead>
                              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                <TableCell>
                                  <strong>Associate</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Project Details</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Booking Details</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Receipt No.</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Received Amount</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Distribution Amount</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Comm. %</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Payable Comm.</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Date</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {commissionsLoading && (
                                <TableRow>
                                  <TableCell colSpan={9} align='center'>
                                    <CircularProgress size={20} />
                                  </TableCell>
                                </TableRow>
                              )}
                              {!commissionsLoading && commissionsError && (
                                <TableRow>
                                  <TableCell
                                    colSpan={9}
                                    align='center'
                                    sx={{ color: 'error.main' }}
                                  >
                                    {commissionsError}
                                  </TableCell>
                                </TableRow>
                              )}
                              {!commissionsLoading &&
                                !commissionsError &&
                                commissions.length === 0 && (
                                  <TableRow>
                                    <TableCell colSpan={9} align='center'>
                                      No commission records found for this
                                      booking.
                                    </TableCell>
                                  </TableRow>
                                )}
                              {!commissionsLoading &&
                                !commissionsError &&
                                commissions.map((row) => (
                                  <TableRow key={row._id} hover>
                                    <TableCell>
                                      <Typography
                                        variant='body2'
                                        fontWeight='bold'
                                      >
                                        {row.associate || '-'}
                                      </Typography>
                                      <Typography
                                        variant='caption'
                                        display='block'
                                        color='text.secondary'
                                      >
                                        {row.associatePhone || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant='body2'>
                                        {row.project || '-'}
                                      </Typography>
                                      <Typography
                                        variant='caption'
                                        display='block'
                                        color='text.secondary'
                                      >
                                        {row.unitType} - {row.unitDetail}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography
                                        variant='caption'
                                        display='block'
                                        color='text.secondary'
                                      >
                                        ID: {row.bookingNo}
                                      </Typography>
                                      <Typography
                                        variant='caption'
                                        display='block'
                                        color='text.secondary'
                                      >
                                        Size: {row.unitSize}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography
                                        variant='body2'
                                        fontWeight='bold'
                                        color='primary'
                                      >
                                        {row.receiptNo || '-'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      ₹
                                      {(row.receivedAmount || 0).toLocaleString(
                                        'en-IN',
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      ₹
                                      {(row.paymentAmount || 0).toLocaleString(
                                        'en-IN',
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {row.payableCommissionPercent}%
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: 'success.main',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      ₹
                                      {(
                                        row.payableCommissionAmount || 0
                                      ).toLocaleString('en-IN')}
                                    </TableCell>
                                    <TableCell>
                                      {row.createdAt
                                        ? new Date(
                                          row.createdAt,
                                        ).toLocaleDateString('en-IN')
                                        : '-'}
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* Tab 6/7: Progress (Read-Only) - Adjust index based on cancelled status */}
              {activeTabLabel === 'Progress' && (
                <Box>
                  <Typography
                    variant='h6'
                    fontWeight='bold'
                    color='primary'
                    gutterBottom
                  >
                    Booking Progress Timeline
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  {progressLoading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        py: 4,
                      }}
                    >
                      <CircularProgress />
                      <Typography
                        variant='body2'
                        color='text.secondary'
                        sx={{ ml: 2 }}
                      >
                        Loading progress...
                      </Typography>
                    </Box>
                  ) : progressError ? (
                    <Alert severity='error' sx={{ mb: 2 }}>
                      {progressError}
                    </Alert>
                  ) : progressData.length === 0 ? (
                    <Paper
                      sx={{ p: 3, textAlign: 'center', bgcolor: '#f8f9fa' }}
                    >
                      <Typography variant='body2' color='text.secondary'>
                        No progress data available for this booking.
                      </Typography>
                    </Paper>
                  ) : (
                    <Box sx={{ position: 'relative', pl: 4 }}>
                      {progressData.map((item, idx) => {
                        // Map API status to display status
                        const status = (
                          item.status ||
                          item.progressStatus ||
                          'pending'
                        ).toLowerCase();
                        const isCompleted =
                          status === 'completed' ||
                          status === 'done' ||
                          status === 'finished';
                        const isInProgress =
                          status === 'in-progress' ||
                          status === 'in_progress' ||
                          status === 'processing';
                        const isPending = !isCompleted && !isInProgress;

                        // Format date
                        const progressDate =
                          item.createdAt ||
                          item.updatedAt ||
                          item.date ||
                          item.timestamp;
                        const formattedDate = progressDate
                          ? new Date(progressDate).toLocaleString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                          })
                          : 'Date not available';

                        // Get title from progressStage, fallback to other fields
                        const title =
                          item.progressStage ||
                          item.title ||
                          item.stage ||
                          item.milestone ||
                          `Progress ${idx + 1}`;
                        // Get description directly from API
                        const description =
                          item.description ||
                          item.remark ||
                          item.notes ||
                          item.details ||
                          'No description available';
                        // Get addedBy for display
                        const addedBy = item.addedBy || item.createdBy || '';

                        return (
                          <Box
                            key={item._id || idx}
                            sx={{ mb: 3, position: 'relative' }}
                          >
                            <Box
                              sx={{
                                position: 'absolute',
                                left: -20,
                                top: 0,
                                width: 16,
                                height: 16,
                                borderRadius: '50%',
                                bgcolor: isCompleted
                                  ? '#22c55e'
                                  : isInProgress
                                    ? '#22c55e'
                                    : '#22c55e',
                                border: '3px solid white',
                                boxShadow: '0 0 0 3px rgba(34,197,94,0.2)',
                              }}
                            />
                            {idx < progressData.length - 1 && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  left: -13,
                                  top: 16,
                                  width: 2,
                                  height: 50,
                                  bgcolor: '#22c55e',
                                }}
                              />
                            )}
                            <Paper
                              sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: '1px solid #f0f0f0',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  mb: 0.5,
                                }}
                              >
                                <Typography variant='body1' fontWeight='600'>
                                  {title}
                                </Typography>
                                {isCompleted && (
                                  <CheckCircleOutline
                                    color='primary'
                                    fontSize='small'
                                  />
                                )}
                                {isInProgress && (
                                  <WatchLater
                                    color='warning'
                                    fontSize='small'
                                  />
                                )}
                              </Box>
                              <Typography
                                variant='caption'
                                color='text.secondary'
                                display='block'
                              >
                                {formattedDate}
                                {addedBy && ` • By ${addedBy}`}
                              </Typography>
                              <Typography
                                variant='body2'
                                color='text.secondary'
                                sx={{ mt: 1 }}
                              >
                                {description}
                              </Typography>
                            </Paper>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              )}

              {/* Tab 7/8: Booking Status (Read-Only) - Adjust index based on cancelled status */}
              {((selectedBooking?.status === 'cancelled' &&
                viewTabValue === 8) ||
                (selectedBooking?.status !== 'cancelled' &&
                  viewTabValue === 7)) && (
                  <Box>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      color='primary'
                      gutterBottom
                    >
                      Booking Status Management
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label='Current Status'
                          defaultValue={selectedBooking.status}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label='Status Change Date'
                          type='date'
                          defaultValue={new Date().toISOString().split('T')[0]}
                          InputLabelProps={{ shrink: true }}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          sx={{
                            p: 3,
                            bgcolor: 'white',
                            border: '1px solid #e0e0e0',
                          }}
                        >
                          <Typography
                            variant='subtitle2'
                            fontWeight='bold'
                            gutterBottom
                          >
                            Status History
                          </Typography>
                          <Divider sx={{ my: 2 }} />
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Box>
                                <Typography variant='body2'>
                                  <strong>Initial</strong> → Changed to{' '}
                                  <strong>Booked</strong>
                                </Typography>
                                <Typography
                                  variant='caption'
                                  color='text.secondary'
                                >
                                  Reason: New booking created, initial payment
                                  received
                                </Typography>
                              </Box>
                              <Typography
                                variant='caption'
                                color='text.secondary'
                              >
                                2025-01-01 10:30 AM
                              </Typography>
                            </Box>
                            <Divider />
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Box>
                                <Typography variant='body2'>
                                  <strong>Booked</strong> → Changed to{' '}
                                  <strong>Under Verification</strong>
                                </Typography>
                                <Typography
                                  variant='caption'
                                  color='text.secondary'
                                >
                                  Reason: Documents submitted for verification
                                </Typography>
                              </Box>
                              <Typography
                                variant='caption'
                                color='text.secondary'
                              >
                                2025-01-02 02:15 PM
                              </Typography>
                            </Box>
                          </Box>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                )}

              {/* Tab 8/9: Booking Draft (Read-Only) - Adjust index based on cancelled status */}
              {((selectedBooking?.status === 'cancelled' &&
                viewTabValue === 9) ||
                (selectedBooking?.status !== 'cancelled' &&
                  viewTabValue === 8)) && (
                  <Box>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      color='primary'
                      gutterBottom
                    >
                      Booking Draft & Notes
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          multiline
                          rows={8}
                          label='Draft Notes'
                          defaultValue='Customer interested in Plot P105. Negotiating on final price. Follow up pending for additional discount request.'
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          sx={{
                            p: 3,
                            bgcolor: 'white',
                            border: '1px solid #e0e0e0',
                          }}
                        >
                          <Typography
                            variant='subtitle2'
                            fontWeight='bold'
                            gutterBottom
                          >
                            Draft History
                          </Typography>
                          <Divider sx={{ my: 2 }} />
                          <Typography variant='body2' color='text.secondary'>
                            Last saved: 2025-01-20 10:30 AM by Admin
                          </Typography>
                          <Typography
                            variant='body2'
                            color='text.secondary'
                            sx={{ mt: 1 }}
                          >
                            Previous draft: 2025-01-19 03:45 PM by Admin
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3, gap: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={handleCloseViewDialog}
            variant='outlined'
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              px: 4,
              borderRadius: 2,
            }}
          >
            Close
          </Button>
          <Button
            variant='contained'
            startIcon={<PictureAsPdfIcon />}
            color='primary'
            onClick={() => setBookingPdfOpen(true)}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              px: 4,
              borderRadius: 2,
            }}
          >
            Booking PDF
          </Button>
        </DialogActions>
      </Dialog>

      <BookingDetailsPDF
        open={pdfDialogOpen}
        onClose={() => {
          setPdfDialogOpen(false);
          setAutoPrintReceipt(false);
        }}
        type={pdfType}
        data={pdfType === 'list' ? displayData : selectedReceipt}
        extraData={selectedBooking}
        autoPrint={autoPrintReceipt}
      />

      <DownloadBookingTabPDF
        open={bookingPdfOpen}
        onClose={() => setBookingPdfOpen(false)}
        booking={selectedBooking}
      />

      {/* Refund Receipt Creation Dialog */}
      <Dialog
        open={refundDialogOpen}
        onClose={handleCloseRefundDialog}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Receipt color='primary' />
            <Typography variant='h6' fontWeight='bold'>
              Create Refund Receipt
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {(() => {
                const refundSummary = getRefundSummary();
                return (
                  <Alert severity='info' sx={{ mb: 2 }}>
                    <Typography variant='body2'>
                      <strong>Pending Refund Amount:</strong> ₹
                      {refundSummary.pending.toLocaleString('en-IN')}
                    </Typography>
                    <Typography variant='caption' color='text.secondary'>
                      (Total: ₹{refundSummary.total.toLocaleString('en-IN')} -
                      Processed: ₹{refundSummary.processed.toLocaleString('en-IN')})
                    </Typography>
                  </Alert>
                );
              })()}
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label='Refund Amount'
                type='number'
                value={refundFormData.amount}
                onChange={(e) =>
                  handleRefundFormChange('amount', e.target.value)
                }
                required
                helperText={`Maximum refund amount: ₹${getRefundSummary().pending.toLocaleString('en-IN')}`}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>₹</InputAdornment>
                  ),
                }}
                inputProps={{
                  min: 0,
                  step: 0.01,
                  max: getRefundSummary().pending,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label='Refund Date'
                type='date'
                value={refundFormData.receivedDate}
                onChange={(e) =>
                  handleRefundFormChange('receivedDate', e.target.value)
                }
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Payment Type</InputLabel>
                <Select
                  value={refundFormData.paymentType}
                  onChange={(e) =>
                    handleRefundFormChange('paymentType', e.target.value)
                  }
                  label='Payment Type'
                >
                  <MenuItem value='partialPayment'>Partial Payment</MenuItem>
                  <MenuItem value='fullPayment'>Full Payment</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                options={[
                  'cash',
                  'bankTransfer',
                  'cheque',
                  'creditCard',
                  'debitCard',
                  'upi',
                  'onlineTransfer',
                  'dd',
                  'neft',
                  'rtgs',
                ]}
                value={refundFormData.mode || null}
                onChange={(event, newValue) =>
                  handleRefundFormChange('mode', newValue || '')
                }
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Payment Mode'
                    placeholder='Select or enter'
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label='Reference Number'
                value={refundFormData.refNo}
                onChange={(e) =>
                  handleRefundFormChange('refNo', e.target.value)
                }
                placeholder='e.g., REFUND-UTR-12345'
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                freeSolo
                options={banks.map((option) => option.name)}
                value={refundFormData.bankName || ''}
                onInputChange={(event, newInputValue) => {
                  handleRefundFormChange('bankName', newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Bank Name'
                    placeholder='Select or enter Bank Name'
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label='Remarks'
                value={refundFormData.otherRemark}
                onChange={(e) =>
                  handleRefundFormChange('otherRemark', e.target.value)
                }
                multiline
                rows={3}
                placeholder='Enter any additional remarks'
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseRefundDialog} disabled={creatingRefund}>
            Cancel
          </Button>
          {canWriteBooking && canCancelBooking && (
            <Button
              variant='contained'
              color='primary'
              onClick={handleCreateRefundReceipt}
              disabled={creatingRefund}
              startIcon={
                creatingRefund ? <CircularProgress size={20} /> : <Receipt />
              }
            >
              {creatingRefund ? 'Creating...' : 'Create Refund'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BookingDetaila;
